export const translations = {
  fr: {
    appName: "Rahma Bat A",
    appShort: "Syndic Copro",
    // nav
    nav_home: "Accueil",
    nav_finances: "Finances",
    nav_action: "Action",
    nav_announcements: "Annonces",
    nav_more: "Plus",
    // auth
    login: "Se connecter",
    logout: "Déconnexion",
    email: "Email",
    login_title: "Bienvenue",
    login_subtitle: "Gérez votre copropriété en toute transparence",
    demo_badge: "Résidence de démonstration",
    demo_hint: "Accès démo — explorez librement",
    demo_fill: "Remplir l'accès démo",
    login_error: "Email ou mot de passe incorrect",
    // roles
    role_president: "Président (Syndic)",
    role_tresorier: "Trésorier",
    role_conseil: "Conseil syndical",
    role_coproprietaire: "Copropriétaire",
    role_gardien: "Gardien",
    // dashboard
    hello: "Bonjour",
    balance: "Solde de caisse",
    reserve: "Réserve accumulée",
    total_revenue: "Revenus totaux",
    total_expense: "Dépenses totales",
    cash: "Espèces",
    bank: "Banque",
    next_payment: "Prochain loyer antenne",
    available_funds: "Fonds disponibles",
    open_tickets: "Tickets ouverts",
    quick_actions: "Actions rapides",
    report_problem: "Signaler un problème",
    add_expense: "Ajouter une dépense",
    emergency: "Urgences",
    pinned_announcements: "Annonces épinglées",
    recent_expenses: "Dernières dépenses",
    view_all: "Tout voir",
    financial_health: "Santé financière de l'immeuble",
    saved_this_period: "Mis de côté",
    // finances
    feed: "Fil",
    bank_account: "Compte bancaire",
    antenna: "Antenne",
    reports: "Rapports",
    transparency_feed: "Fil de transparence",
    transparency_sub: "Chaque dirham, en temps réel",
    income: "Revenu",
    expense: "Dépense",
    receipt: "Justificatif",
    view_receipt: "Voir le justificatif",
    no_receipt: "Pas de justificatif",
    ask_question: "Poser une question",
    questions: "Questions",
    your_question: "Votre question sur cette dépense",
    send: "Envoyer",
    answer: "Répondre",
    cancelled: "Annulé",
    by: "par",
    // bank
    official_balance: "Solde officiel",
    statement_date: "Date du relevé",
    updated_ago: "Mis à jour le",
    reconciliation_ok: "Rapprochement OK — le solde correspond au relevé",
    reconciliation_warn: "Écarts à expliquer",
    matched_ops: "Opérations rapprochées",
    unmatched: "Écarts détectés",
    import_statement: "Importer un relevé",
    operations: "Opérations du relevé",
    no_bank: "Aucun relevé importé pour l'instant",
    // antenna
    antenna_contract: "Contrat de l'antenne",
    operator: "Opérateur",
    quarterly_amount: "Loyer trimestriel",
    contract_end: "Fin du contrat",
    payments_history: "Historique des versements",
    // reports
    quarterly_summary: "Synthèse trimestrielle",
    expenses_by_category: "Dépenses par catégorie",
    generate_pdf: "Rapport PDF",
    quarter: "Trimestre",
    // action / add expense
    action_title: "Que voulez-vous faire ?",
    scan_invoice: "Scanner une facture",
    scan_sub: "Photo → l'IA remplit tout",
    ss_button: "Dépôt intelligent (IA)",
    ss_button_sub: "Photo ou scan → l'IA range tout au bon endroit",
    ss_title: "Dépôt intelligent",
    ss_drop: "Photographier ou choisir un fichier",
    ss_hint: "Facture, relevé bancaire, contrat, PV… en français ou en arabe",
    ss_pages_q: "Avez-vous ajouté TOUTES les pages du document ?",
    ss_pages_hint: "Ajoutez chaque page (ex : relevé de plusieurs pages) avant de lancer l'analyse — l'IA lira tout comme un seul document.",
    ss_add_page: "Ajouter une page",
    ss_all_added: "C'est tout → Analyser",
    ss_pages_added: "pièce(s) ajoutée(s)",
    ss_single_pdf: "Un PDF/CSV/Excel doit être envoyé seul. Pour plusieurs pages, utilisez des photos.",
    doc_multi_hint: "Plusieurs pages ? Ajoutez chaque photo : elles seront fusionnées en un seul PDF.",
    ss_analyzing: "L'IA lit votre document…",
    ss_uploading: "Envoi des photos…",
    ss_dont_leave: "Ne quittez pas cette page pendant l'analyse, sinon vous perdrez vos photos.",
    ss_leave_confirm: "L'IA est en train de lire vos photos. Si vous quittez maintenant, vous perdrez ce document. Quitter quand même ?",
    ss_detected: "Document reconnu",
    ss_type_facture: "Facture / dépense",
    ss_type_releve_bancaire: "Relevé bancaire",
    ss_type_document: "Document officiel",
    ss_dest_facture: "Sera enregistrée dans Finances → Dépenses (justificatif archivé)",
    ss_dest_releve_bancaire: "Sera importé dans Finances → Banque avec rapprochement automatique",
    ss_dest_document: "Sera rangé dans la bibliothèque Documents",
    ss_wrong_type: "Ce n'est pas le bon type ? Corrigez :",
    ss_confirm: "Confirmer et ranger",
    ss_saved_facture: "Dépense enregistrée dans les finances",
    ss_saved_releve_bancaire: "Relevé importé — rapprochement effectué",
    ss_saved_document: "Document rangé dans la bibliothèque",
    ss_view: "Voir le résultat",
    ss_scan_more: "Scanner un autre document",
    ss_tx_count: "opérations détectées",
    ss_statement_date: "Date du relevé",
    ss_closing_balance: "Solde final (MAD)",
    ss_matched: "rapprochées",
    ss_anomalies: "anomalies",
    ss_analyze_failed: "L'IA n'a pas réussi à lire ce document. Réessayez avec une photo plus nette.",
    ss_amount_required: "Montant obligatoire",
    ss_title_required: "Titre obligatoire",
    ss_type_rib: "RIB",
    ss_dest_rib: "Sera rangé dans Finances → Banque → RIB (président & trésorier)",
    ss_saved_rib: "RIB enregistré dans Finances → Banque",
    ss_rib_required: "Numéro de RIB obligatoire",
    ss_bank_required: "Date du relevé et solde final obligatoires",
    rib_kind_residence: "RIB de la résidence",
    rib_kind_externe: "Autre RIB (fournisseur…)",
    rib_label: "Libellé (ex : nom du fournisseur)",
    rib_holder: "Titulaire du compte",
    rib_bank: "Banque",
    rib_agency: "Agence",
    rib_number: "N° RIB (24 chiffres)",
    rib_iban: "IBAN (facultatif)",
    rib_residence: "RIB de la résidence",
    rib_externes: "RIB enregistrés (fournisseurs…)",
    rib_copy: "Copier",
    rib_copied: "RIB copié",
    copy_failed: "Copie impossible",
    load_failed: "Impossible de charger les données. Vérifiez votre connexion.",
    bkp_title: "Sauvegardes",
    bkp_sub: "Sauvegarde complète chiffrée + restauration",
    bkp_need_password: "Définissez d'abord un mot de passe de chiffrement",
    bkp_password_hint: "Il protège vos sauvegardes. Sans lui, aucune sauvegarde n'est possible.",
    bkp_set_password: "Définir le mot de passe",
    bkp_password_warn: "⚠️ Notez-le précieusement : il est INDISPENSABLE pour restaurer. Personne ne peut le récupérer.",
    bkp_password_ph: "Mot de passe de chiffrement",
    bkp_password_confirm: "Confirmer le mot de passe",
    bkp_password_min: "8 caractères minimum",
    bkp_password_mismatch: "Les mots de passe ne correspondent pas",
    bkp_last: "Dernière sauvegarde",
    bkp_never: "Aucune pour l'instant",
    bkp_run_now: "Sauvegarder maintenant",
    bkp_running: "Sauvegarde en cours…",
    bkp_done: "Sauvegarde terminée ✓",
    bkp_done_with_errors: "Sauvegarde faite, mais un envoi a échoué (voir l'historique)",
    bkp_failed: "Échec de l'opération",
    bkp_daily: "Sauvegarde automatique quotidienne",
    bkp_hour: "Heure",
    bkp_retention: "Garder (nb)",
    bkp_schedule_hint: "Chaque jour à l'heure choisie (heure du Maroc). On garde les N dernières, les plus anciennes sont supprimées.",
    bkp_destinations: "Destinations",
    bkp_dest_hint: "Envoyez chaque sauvegarde vers un ou plusieurs stockages externes. Remplissez les identifiants de connexion.",
    bkp_disabled: "Désactivée",
    bkp_test: "Tester",
    bkp_testing: "Test de connexion…",
    bkp_test_ok: "Connexion réussie ✓",
    bkp_test_fail: "Connexion impossible",
    bkp_dest_delete_confirm: "Supprimer cette destination ?",
    bkp_dest_label: "Nom (ex : Glacier perso)",
    bkp_folder: "Dossier / préfixe (optionnel)",
    bkp_s3_endpoint: "Endpoint (vide = AWS ; sinon Wasabi/B2/MinIO)",
    bkp_az_account: "Nom du compte de stockage",
    bkp_az_key: "Clé du compte",
    bkp_sftp_user: "Utilisateur",
    bkp_sftp_dir: "Dossier distant (ex : /volume1/backups)",
    bkp_sftp_pw: "Mot de passe",
    bkp_secret_keep: "(laisser vide = inchangé)",
    bkp_history: "Historique",
    bkp_none: "Aucune sauvegarde pour l'instant",
    bkp_files: "fichiers",
    bkp_records: "enregistrements",
    bkp_collections: "modules",
    bkp_kind_manual: "Manuelle",
    bkp_kind_auto: "Automatique",
    bkp_kind_pre_restore: "Avant restauration",
    bkp_restore: "Restaurer",
    bkp_restore_from_file: "Restaurer depuis un fichier",
    bkp_restore_file_hint: "Choisissez une archive .zip téléchargée et saisissez son mot de passe. Utile si le serveur est perdu ou piraté.",
    bkp_choose_file: "Choisissez un fichier",
    bkp_delete_confirm: "Supprimer cette sauvegarde ?",
    bkp_restore_confirm1: "RESTAURER va REMPLACER toutes les données actuelles par celles de cette sauvegarde. Continuer ?",
    bkp_restore_confirm2: "Êtes-vous ABSOLUMENT sûr ? Une sauvegarde de sécurité sera créée juste avant.",
    bkp_restoring: "Restauration en cours…",
    bkp_restored: "Restauration terminée ✓",
    bkp_bad_password: "Mot de passe incorrect pour cette archive",
    wipe_zone_title: "Zone de danger",
    wipe_title: "Vider toutes les données",
    wipe_desc: "Efface DÉFINITIVEMENT toutes les données (dépenses, revenus, tickets, annonces, documents, AG, cotisations, comptes des autres membres…). Conserve uniquement VOTRE compte, l'immeuble et les logements (remis à vide).",
    wipe_backup_first: "Faites d'abord une sauvegarde ci-dessus si vous voulez pouvoir tout restaurer.",
    wipe_button: "Vider toutes les données",
    wipe_modal_title: "Vider toutes les données ?",
    wipe_warn: "Action IRRÉVERSIBLE. Seront supprimés : toutes les données de la résidence et TOUS les comptes sauf le vôtre. Les sauvegardes sont conservées.",
    wipe_kept: "Compte conservé",
    wipe_confirm_label: "Pour confirmer, tapez SUPPRIMER en majuscules :",
    wipe_confirm_ph: "SUPPRIMER",
    wipe_confirm_mismatch: "Tapez exactement SUPPRIMER pour confirmer",
    wipe_running: "Suppression en cours…",
    wipe_done: "Données vidées — la résidence est prête pour le lancement ✓",
    wipe_items: "éléments supprimés",
    rib_delete_confirm: "Supprimer ce RIB ?",
    occ_label: "Qui occupe le logement ?",
    occ_occupant: "J'y habite",
    occ_loue: "Loué à un locataire",
    occ_tenant_name: "Nom du locataire (facultatif)",
    occ_tenant_phone: "Téléphone du locataire (facultatif)",
    occ_why: "Pourquoi ces coordonnées ? En cas d'urgence dans l'immeuble (fuite d'eau, incendie, dégât…), le syndic doit pouvoir joindre rapidement la personne qui habite réellement le logement. Elles ne sont partagées qu'avec votre accord.",
    lot_occupant_badge: "Propriétaire occupant",
    lot_tenant: "Locataire",
    lot_ask_tenant: "Voir le contact du locataire (avec l'accord du propriétaire)",
    lot_request_pending: "Demande envoyée — en attente de l'accord du propriétaire",
    lot_request_sent: "Demande envoyée au propriétaire",
    recon_to_revenue: "Enregistrer comme revenu",
    recon_to_revenue_done: "Revenu enregistré — trésorerie à jour",
    ant_title: "Contrat antenne",
    ant_operator: "Opérateur",
    ant_quarterly: "Loyer trimestriel (MAD)",
    ant_start: "Début du contrat",
    ant_end: "Fin du contrat (facultatif)",
    ant_contact: "Contact opérateur (facultatif)",
    ant_next_due: "Prochain versement attendu",
    ant_overdue: "Versement en retard !",
    ant_last_payment: "Dernier versement",
    ant_setup: "Configurer le contrat antenne",
    ant_required: "Loyer trimestriel et date de début obligatoires",
    welcome_title: "Bienvenue chez vous",
    welcome_sub: "Cet espace est le vôtre : toute la vie de la résidence, en toute transparence.",
    welcome_f1: "Suivez chaque dépense avec son justificatif, le solde en banque et les rapports.",
    welcome_f2: "Un souci dans l'immeuble ? Signalez-le en 30 secondes (fuite, ascenseur, propreté…).",
    welcome_f3: "Consultez les documents officiels et votez aux assemblées générales.",
    welcome_f4: "Dans votre profil, indiquez si vous habitez le logement ou s'il est loué — utile en cas d'urgence.",
    welcome_cta: "C'est parti",
    reg_lang_label: "Votre langue",
    reg_lang_hint: "Le site et les e-mails seront dans cette langue. Vous pourrez la changer à tout moment avec le bouton en haut de l'écran.",
    take_photo: "Prendre une photo / choisir",
    analyzing: "Analyse en cours par l'IA...",
    supplier: "Fournisseur",
    amount: "Montant (MAD)",
    vat: "TVA (MAD)",
    date: "Date",
    category: "Catégorie",
    account: "Compte",
    note: "Note",
    save: "Enregistrer",
    saved: "Enregistré",
    add_revenue: "Encaisser le loyer antenne",
    // tickets
    tickets: "Demandes & Incidents",
    new_ticket: "Nouvelle demande",
    ticket_category: "Type",
    description: "Description",
    location: "Localisation (étage/zone)",
    status: "Statut",
    create: "Créer",
    my_tickets: "Mes demandes en cours",
    no_tickets: "Aucune demande en cours — tout va bien dans la résidence",
    assigned_to: "Assigné à",
    comment: "Commentaire",
    // announcements
    announcements: "Annonces",
    new_announcement: "Nouvelle annonce",
    title: "Titre",
    message: "Message",
    pin: "Épingler",
    no_announcements: "Aucune annonce pour l'instant",
    // more
    building: "Immeuble & Lots",
    residents: "Résidents",
    residents_sub: "Vie privée respectée — coordonnées sur autorisation",
    apartment: "Appartement",
    you_tag: "Vous",
    request_contact: "Demander les coordonnées",
    request_sent: "Demande envoyée",
    incoming_requests: "Demandes reçues",
    wants_contact: "souhaite voir vos coordonnées",
    authorize: "Autoriser",
    refuse: "Refuser",
    privacy_note: "Par respect de la vie privée, seuls le prénom, l'initiale et l'appartement sont visibles.",
    contact_visible: "Coordonnées partagées",
    ideas: "Boîte à idées",
    ideas_sub: "Proposez, votez, améliorons la résidence ensemble",
    new_idea: "Proposer une idée",
    idea_title: "Titre de l'idée",
    idea_desc: "Décrivez votre idée",
    visibility: "Visibilité",
    vis_public: "Visible par tous",
    vis_prive: "Privé (Président & Trésorier)",
    support: "Je soutiens",
    supported: "Soutenu",
    supports: "soutiens",
    no_ideas: "Aucune idée pour l'instant — lancez la première !",
    private_idea: "Privé",
    ist_nouvelle: "Nouvelle",
    ist_etude: "À l'étude",
    ist_retenue: "Retenue",
    ist_refusee: "Écartée",
    auto_translated: "Traduit automatiquement",
    show_original: "Voir l'original",
    show_translation: "Voir la traduction",
    translation_hint: "Traduction automatique — en cas de doute, contactez l'auteur.",
    documents: "Documents",
    documents_sub: "Règlement, contrats et documents officiels de la copropriété",
    doc_reglement: "Règlement de copropriété",
    doc_contrat: "Contrats fournisseurs",
    doc_legal: "Documents légaux",
    doc_pv: "PV d'assemblée",
    doc_attestation: "Attestations",
    doc_facture: "Factures importantes",
    doc_autre: "Autres",
    add_document: "Ajouter un document",
    edit_document: "Modifier",
    doc_title: "Titre du document",
    doc_description: "Description (facultatif)",
    doc_body: "Texte du règlement",
    doc_body_ph: "Saisissez ou collez le texte du règlement…",
    doc_category: "Catégorie",
    doc_supplier: "Fournisseur",
    doc_service_type: "Type de service (ascenseur, ménage…)",
    doc_start: "Début",
    doc_end: "Fin",
    doc_amount: "Montant annuel (MAD)",
    doc_file: "Fichier (PDF ou photo)",
    choose_file: "Choisir un fichier / scan",
    take_photo_cam: "Prendre une photo",
    consult: "Consulter",
    download: "Télécharger",
    no_documents: "Aucun document dans cette catégorie",
    download_restricted: "Seuls le président et le trésorier peuvent télécharger les fichiers.",
    file_attached: "Fichier joint",
    uploading: "Envoi en cours…",
    ongoing: "En cours",
    doc_vis_public: "Visible par tous",
    doc_vis_bureau: "Réservé au bureau",
    doc_private_badge: "Bureau",
    quarterly_report: "Rapport financier trimestriel",
    report_period: "Choisissez le trimestre",
    download_report: "Télécharger le PDF",
    share_whatsapp: "Partager WhatsApp",
    wa_alert: "Alerter WhatsApp",
    wa_report_footer: "Détail complet dans l'app Rahma Bat A — transparence totale des comptes.",
    treasury_total: "Trésorerie totale",
    cash_box: "Caisse",
    cash_box_full: "Caisse liquide (chez le trésorier)",
    bank_balance_label: "Solde bancaire",
    advances_due: "Avances à rembourser",
    pending_expenses: "En attente de paiement",
    cash_movements: "Mouvements de caisse",
    no_movements: "Aucun mouvement de caisse",
    add_withdrawal: "Retrait bancaire → caisse",
    withdrawal_amount: "Montant retiré (MAD)",
    withdrawal_label: "Libellé (banque, motif…)",
    record_withdrawal: "Enregistrer le retrait",
    mov_withdrawal: "Retrait bancaire",
    mov_expense: "Paiement facture",
    mov_reimbursement: "Remboursement avance",
    payment: "Paiement",
    payment_status_label: "Statut de paiement",
    pay_pending: "En attente",
    pay_paid: "Payée",
    payment_method_label: "Mode de paiement",
    pm_cash: "Espèces (caisse)",
    pm_bank: "Virement / banque",
    pm_advance: "Avance (fonds perso)",
    pay_now: "Régler",
    choose_pay_method: "Régler la dépense",
    reimburse_now: "Rembourser",
    reimburse_title: "Rembourser l'avance",
    badge_pending: "En attente",
    badge_cash: "Payée cash",
    badge_bank: "Payée banque",
    badge_advance: "Avance à rembourser",
    badge_reimbursed: "Remboursée",
    advanced_by_label: "Avancé par",
    pay_advanced: "Avancée par…",
    advance_by_select: "Qui a avancé l'argent ?",
    advance_confirm_label: "Confirmer ce nom",
    advance_confirmed: "Nom confirmé",
    advance_select_required: "Sélectionnez qui a avancé l'argent",
    advance_confirm_required: "Confirmez le nom de la personne qui a avancé",
    advances_recap_title: "Avances à rembourser",
    advances_recap_sub: "Total dû par personne — pour ne rien oublier",
    advances_none: "Aucune avance en attente de remboursement",
    advances_grand_total: "Total à rembourser",
    advance_invoices: "facture(s)",
    reimburse_person_confirm: "Confirmer le remboursement",
    reimburse_person_msg: "Vous allez rembourser",
    to_person: "à",
    reimburse_method_hint: "En espèces, le montant sera débité de la caisse.",
    confirm_btn: "Confirmer",
    justif_required: "Ajoutez d'abord le justificatif (photo/scan) pour une avance",
    cash_only_tresorier: "Seul le trésorier peut payer en espèces",
    topup_title: "Alimenter la caisse",
    topup_sub: "Retrait bancaire → espèces (double validation)",
    topup_amount: "Montant du retrait (MAD)",
    topup_label: "Banque / libellé",
    topup_proof: "Justificatif de retrait (photo/scan)",
    topup_proof_required: "Ajoutez le justificatif du retrait",
    request_topup: "Demander l'alimentation",
    topups_history: "Alimentations de la caisse",
    topup_pending: "En attente de validation",
    topup_valid: "Validée",
    topup_refused: "Refusée",
    awaiting_president: "En attente du président",
    approve: "Valider",
    reject: "Refuser",
    reject_reason: "Motif du refus",
    requested_by: "Demandé par",
    validated_by: "Validé par",
    double_val_note: "Toute alimentation exige la validation du trésorier ET du président.",
    notifications: "Notifications",
    no_notifications: "Aucune notification",
    push_settings: "Notifications push",
    push_enable: "Activer les notifications",
    push_enable_desc: "Recevez les alertes importantes (validations, anomalies, annonces) même quand l'application est fermée.",
    push_activate: "Activer",
    push_later: "Plus tard",
    push_on: "Notifications activées",
    push_off: "Notifications désactivées",
    push_enabled_toast: "Notifications activées 🔔",
    push_disabled_toast: "Notifications désactivées",
    push_denied: "Notifications bloquées dans les réglages du navigateur.",
    push_unsupported: "Votre navigateur ne gère pas les notifications push.",
    push_test: "Envoyer un test",
    push_test_sent: "Notification de test envoyée",
    push_ios_hint: "Sur iPhone : ajoutez d'abord l'app à l'écran d'accueil (Partager → Sur l'écran d'accueil), puis activez les notifications.",
    mark_all_read: "Tout marquer comme lu",
    statement_imported: "Relevé importé et rapproché",
    reconciling: "Rapprochement par IA…",
    recon_engine_ai: "Rapproché par IA",
    recon_engine_algo: "Rapprochement automatique",
    recon_matches: "Correspondances",
    recon_anomalies: "Anomalies à traiter",
    recon_bank_only: "Au relevé, absente de l'app",
    recon_app_only: "Dans l'app, absente du relevé",
    recon_resolve: "Résoudre / commenter",
    recon_mark_resolved: "Marquer résolue",
    recon_resolved: "Anomalie résolue",
    recon_resolved_plural: "Anomalies résolues",
    recon_resolved_by: "Résolue par",
    recon_reopen: "Rouvrir",
    recon_comment_ph: "Expliquez cette anomalie (ex : virement en attente, frais bancaires…)",
    recon_comment_required: "Ajoutez un commentaire pour résoudre l'anomalie",
    recon_open_count: "anomalies ouvertes",
    recon_accept_all: "Tout accepter",
    recon_accept_all_confirm: "Marquer TOUTES les anomalies ouvertes comme acceptées ? Utile pour solder rapidement un ancien relevé sans les commenter une par une.",
    recon_accept_all_done: "Anomalies acceptées",
    recurring_label_suggest: "Dépense récurrente ? Libellé proposé",
    recurring_label_use: "Utiliser",
    login_id_ph: "prénom.initiale (ex : karim.b)",
    login_pin_ph: "Code PIN (4 à 6 chiffres)",
    login_remember: "Rester connecté sur cet appareil",
    forgot_identifier: "Identifiant oublié ?",
    forgot_pin: "Code PIN oublié ?",
    have_invite: "J'ai un code d'invitation",
    forgot_sent: "Le président a été prévenu",
    forgot_pin_help: "Saisissez votre identifiant : le président sera prévenu et réinitialisera votre code.",
    forgot_identifier_help: "Saisissez votre numéro de téléphone : le président vous renverra votre identifiant.",
    phone_ph: "Numéro de téléphone",
    notify_president: "Prévenir le président",
    back: "Retour",
    continue: "Continuer",
    activation_title: "Activation du compte",
    activation_step0_help: "Saisissez l'identifiant et le code d'invitation reçus par WhatsApp.",
    invite_code_ph: "Code d'invitation (ex : K7M2PA)",
    choose_pin: "Choisissez votre code PIN",
    pin_rule: "Un code de 4 à 6 chiffres, que vous choisissez.",
    confirm_pin: "Confirmez le code PIN",
    pin_mismatch: "Les codes PIN ne correspondent pas",
    change_pin: "Changer mon code PIN",
    change_pin_title: "Changer votre code PIN",
    change_pin_required_title: "Changement de code PIN requis",
    change_pin_required_sub: "Pour votre sécurité, choisissez un nouveau code PIN personnel avant de continuer.",
    change_pin_ok: "Code PIN mis à jour",
    change_pin_cta: "Valider le nouveau code",
    current_pin_label: "Code PIN actuel",
    new_pin_label: "Nouveau code PIN",
    confirm_pin_label: "Confirmez le nouveau code",
    pin_need_6: "Le code PIN doit contenir 6 chiffres",
    pin_policy_hint: "6 chiffres. Évitez les suites (123456) et les chiffres identiques (000000).",
    session_expired_inactive: "Session expirée pour inactivité. Reconnectez-vous.",
    session_expiring_title: "Session bientôt expirée",
    session_expiring_msg: "Vous allez être déconnecté pour inactivité.",
    stay_connected: "Rester connecté",
    complete_profile: "Complétez votre profil",
    profile_help: "Ces informations alimentent l'annuaire des résidents.",
    full_name: "Nom complet",
    apartment_label: "Numéro de logement",
    finish_activation: "Activer mon compte",
    activation_done: "Compte activé !",
    activation_done_help: "Bienvenue. Vous êtes maintenant connecté.",
    directory_notice: "Dans l'annuaire, les voisins ne voient que votre logement, prénom et initiale. Vos coordonnées ne sont partagées qu'après une demande de contact acceptée.",
    enter_app: "Entrer dans l'application",
    profile_required: "Tous les champs du profil sont obligatoires",
    user_management: "Gestion des utilisateurs",
    add_user: "Ajouter",
    role_requests: "Validations en attente",
    awaiting_treasurer: "En attente du trésorier",
    apt: "Logt",
    status_active: "Actif",
    status_invited: "En attente",
    status_disabled: "Désactivé",
    invite_code: "Code d'invitation",
    send_whatsapp: "Inviter par WhatsApp",
    regenerate_code: "Nouveau code",
    edit: "Modifier",
    reset_pin: "Réinitialiser le PIN",
    enable: "Réactiver",
    disable: "Désactiver",
    reset_pin_confirm: "Réinitialiser le code PIN de cet utilisateur ? Un nouveau code d'invitation sera généré.",
    pin_reset_done: "PIN réinitialisé — envoyez le nouveau code",
    code_regenerated: "Nouveau code généré",
    role_approved_toast: "Changement validé",
    role_rejected_toast: "Changement refusé",
    name_required: "Le nom est obligatoire",
    user_created: "Compte créé — envoyez l'invitation",
    identifier_optional: "Identifiant (laisser vide = automatique)",
    email_invite_optional: "E-mail (facultatif — envoie l'invitation par e-mail)",
    email_section: "E-mails",
    email_configured: "Envoi d'e-mails activé",
    email_not_configured: "E-mail pas encore configuré",
    email_test_btn: "Envoyer un e-mail de test",
    email_test_ok: "E-mail de test envoyé",
    create_account: "Créer un compte",
    have_account: "J'ai déjà un compte",
    register_title: "Créer mon compte",
    register_subtitle: "Inscrivez-vous, confirmez votre e-mail, puis le syndic validera votre accès.",
    reg_name_ph: "Nom complet",
    reg_apartment_label: "Votre logement",
    reg_select_apartment: "Choisissez votre logement",
    reg_phone_ph: "Téléphone (WhatsApp)",
    reg_email_ph: "Adresse e-mail",
    reg_pin_ph: "Choisir un code PIN (4 à 6 chiffres)",
    reg_pin_confirm_ph: "Confirmer le code PIN",
    reg_pin_mismatch: "Les codes PIN ne correspondent pas",
    reg_fields_required: "Merci de remplir tous les champs",
    reg_choose_residence: "Choisissez d'abord votre résidence.",
    register_submit: "M'inscrire",
    register_success_title: "Vérifiez votre e-mail 📬",
    register_success_msg: "Nous vous avons envoyé un lien de confirmation. Cliquez dessus pour valider votre adresse, puis attendez la validation du syndic.",
    back_to_login: "Retour à la connexion",
    verify_checking: "Confirmation en cours…",
    verify_success_title: "E-mail confirmé ✅",
    verify_success_msg: "Merci ! Votre demande a été transmise au syndic. Vous pourrez vous connecter dès qu'il aura validé votre compte.",
    verify_already_active: "Votre compte est déjà actif. Vous pouvez vous connecter.",
    verify_error_title: "Lien invalide",
    verify_error_msg: "Ce lien de confirmation est invalide ou a expiré. Recommencez l'inscription.",
    pending_registrations: "Inscriptions en attente",
    no_pending_registrations: "Aucune inscription en attente.",
    rejected_history: "Inscriptions refusées",
    awaiting_email_confirm: "En attente de confirmation de l'e-mail par le résident.",
    approve_registration: "Valider l'inscription",
    registration_approved: "Inscription validée",
    registration_rejected_toast: "Inscription refusée",
    reject_registration_confirm: "Refuser cette inscription ?",
    active_members: "Membres actifs",
    status_pending_email: "E-mail à confirmer",
    status_pending_approval: "À valider",
    status_rejected: "Refusée",
    role_label: "Rôle",
    lang_label: "Langue préférée",
    lang_name_fr: "Français",
    lang_name_ar: "Darija",
    lang_name_en: "English",
    create_user: "Créer le compte",
    suggested_id: "Identifiant proposé",
    treasurer_4eyes_note: "Changer le trésorier exige la validation du trésorier sortant (règle des 4 yeux).",
    force_reason_ph: "Motif si trésorier indisponible (forçage tracé)",
    role_pending: "Validation du trésorier requise",
    profile_updated: "Profil mis à jour",
    edit_profile: "Modifier mon profil",
    sans_facture_toggle: "Prestataire sans facture",
    sans_facture_hint: "Certains artisans ne donnent pas de facture. Renseignez tous les champs ci-dessous.",
    artisan_name: "Nom de l'artisan / entreprise",
    artisan_phone: "Téléphone de l'artisan",
    service_desc: "Description de la prestation",
    intervention_at: "Date et heure de l'intervention",
    sans_facture_badge: "Sans facture — artisan déclaré",
    proof_ok: "Justificatif ajouté",
    add_proof: "Ajouter le justificatif",
    providers: "Prestataires",
    profile: "Mon profil",
    settings: "Paramètres",
    language: "Langue",
    dark_mode: "Mode sombre",
    audit_log: "Journal d'audit",
    lots: "Lots",
    lot_number: "N° de lot",
    duplex: "Duplex",
    duplexes: "duplex",
    the_building: "L'immeuble",
    entrance: "Entrée principale",
    dwellings: "logements",
    assemblies: "Assemblées générales",
    ag_new: "Nouvelle AG",
    ag_none: "Aucune assemblée pour l'instant.",
    ag_ordinaire: "Ordinaire",
    ag_extraordinaire: "Extraordinaire",
    ag_status_brouillon: "Brouillon",
    ag_status_convoquee: "Convoquée",
    ag_status_vote_ouvert: "Vote ouvert",
    ag_status_cloturee: "Clôturée",
    ag_title_label: "Titre de l'AG",
    ag_title_required: "Indiquez le titre de l'AG",
    ag_kind: "Type",
    ag_datetime: "Date et heure",
    ag_place: "Lieu",
    ag_quorum_required: "Quorum",
    ag_agenda: "Ordre du jour",
    ag_add_item: "Ajouter",
    ag_item_title: "Intitulé de la résolution",
    ag_item_desc: "Description (facultatif)",
    ag_requires_vote: "Soumise au vote",
    ag_info_point: "Point d'information (sans vote)",
    ag_create: "Créer l'AG",
    ag_created: "Assemblée créée",
    ag_convene: "Convoquer",
    ag_convened: "AG convoquée — tout le monde est notifié",
    ag_open_vote: "Ouvrir le vote",
    ag_opened: "Vote ouvert",
    ag_close_vote: "Clôturer & publier",
    ag_closed: "AG clôturée — résultats publiés",
    ag_confirm_close: "Clôturer le vote et publier les résultats ?",
    ag_delete: "Supprimer",
    ag_deleted: "AG supprimée",
    ag_confirm_delete: "Supprimer cette AG ?",
    ag_share_convocation: "Partager la convocation",
    ag_share_results: "Partager les résultats",
    ag_download_pv: "Télécharger le PV (PDF)",
    ag_participation: "Participation",
    ag_quorum_reached: "Quorum atteint",
    ag_quorum_not_reached: "Quorum non atteint",
    ag_my_weight: "Votre poids de vote",
    ag_vote_pour: "Pour",
    ag_vote_contre: "Contre",
    ag_vote_abstention: "Abstention",
    ag_submit_vote: "Enregistrer mon vote",
    ag_voted: "Vote enregistré",
    ag_cannot_vote: "Seuls les copropriétaires votent (selon leurs tantièmes).",
    ag_adopted: "Adoptée",
    ag_rejected: "Rejetée",
    maintenance: "Carnet d'entretien",
    legal: "Cadre légal",
    cotisations: "Cotisations",
    cotisations_sub: "Appels de fonds répartis entre les copropriétaires",
    cot_new: "Nouvel appel",
    cot_none: "Aucun appel de fonds pour l'instant.",
    cot_kind_ordinaire: "Ordinaire",
    cot_kind_travaux: "Travaux",
    cot_kind_exceptionnel: "Exceptionnel",
    cot_title_label: "Objet de l'appel (ex. Charges T3)",
    cot_title_required: "Indiquez l'objet de l'appel",
    cot_amount_required: "Indiquez un montant total valide",
    cot_period: "Période",
    cot_period_ph: "Période (ex. T3 2026)",
    cot_method: "Répartition",
    cot_method_tantiemes: "Au prorata des tantièmes",
    cot_method_equal: "À parts égales",
    cot_method_hint: "Au prorata : le montant est réparti selon les tantièmes de chaque lot. À parts égales : montant divisé équitablement entre tous les lots.",
    cot_total: "Montant total (MAD)",
    cot_due: "Échéance",
    cot_note: "Note (facultatif)",
    cot_create: "Émettre l'appel",
    cot_created: "Appel de fonds émis",
    cot_status_open: "En cours",
    cot_status_closed: "Clôturé",
    cot_collected: "Encaissé",
    cot_outstanding: "Reste à recouvrer",
    cot_paid_lots: "réglés",
    cot_charges: "Quotes-parts par lot",
    cot_lot: "Lot",
    cot_amount_due: "Montant appelé",
    cot_remaining: "Reste",
    cs_unpaid: "Impayée",
    cs_partial: "Partielle",
    cs_paid: "Réglée",
    cot_pay: "Encaisser",
    cot_pay_title: "Enregistrer un paiement",
    cot_pay_amount: "Montant (vide = solde restant)",
    cot_pay_date: "Date du paiement",
    cot_pay_note: "Note (facultatif)",
    cot_pay_submit: "Valider le paiement",
    cot_paid_ok: "Paiement enregistré",
    cot_receipt: "Reçu PDF",
    cot_reset: "Annuler",
    cot_reset_confirm: "Annuler tous les paiements de cette quote-part ?",
    cot_reset_ok: "Paiements annulés",
    cot_close: "Clôturer",
    cot_reopen: "Rouvrir",
    cot_closed_ok: "Appel clôturé",
    cot_reopen_ok: "Appel rouvert",
    cot_delete: "Supprimer",
    cot_delete_confirm: "Supprimer cet appel de fonds et toutes ses quotes-parts ?",
    cot_deleted: "Appel supprimé",
    cot_impayes: "Impayés en cours",
    cot_impayes_total: "Total à recouvrer",
    pmth_cash: "Espèces",
    pmth_bank: "Virement / banque",
    pmth_cheque: "Chèque",
    mnt_new: "Nouvelle intervention",
    mnt_edit: "Modifier l'intervention",
    mnt_none: "Aucune intervention enregistrée.",
    mnt_cat_ascenseur: "Ascenseur",
    mnt_cat_etancheite: "Étanchéité",
    mnt_cat_extincteurs: "Extincteurs",
    mnt_cat_plomberie: "Plomberie",
    mnt_cat_electricite: "Électricité",
    mnt_cat_nettoyage: "Nettoyage",
    mnt_cat_espaces_verts: "Espaces verts",
    mnt_cat_autre: "Autre",
    mnt_title: "Intitulé de l'intervention",
    mnt_title_required: "Indiquez l'intitulé de l'intervention",
    mnt_desc: "Description (facultatif)",
    mnt_provider: "Prestataire",
    mnt_phone: "Téléphone",
    mnt_date: "Date réalisée",
    mnt_cost: "Coût",
    mnt_next_due: "Prochaine échéance",
    mnt_status: "Statut",
    mnt_status_fait: "Réalisée",
    mnt_status_planifie: "Planifiée",
    mnt_upcoming: "Prochaines échéances",
    mnt_overdue: "En retard",
    mnt_due_soon: "Bientôt",
    mnt_save: "Enregistrer",
    mnt_created: "Intervention ajoutée",
    mnt_updated: "Intervention modifiée",
    mnt_deleted: "Intervention supprimée",
    mnt_confirm_delete: "Supprimer cette intervention ?",
    rented: "Loué",
    floor: "Étage",
    surface: "Superficie",
    tantiemes: "Tantièmes",
    owner: "Propriétaire",
    common_areas: "Parties communes",
    ca_hall: "Hall",
    ca_escaliers: "Escaliers",
    ca_paliers: "Paliers",
    ca_toit: "Toit (Stah)",
    ca_ascenseur: "Ascenseur",
    ca_loge: "Loge gardien",
    manage_users: "Gérer les utilisateurs",
    // categories
    cat_electricite: "Électricité",
    cat_eau: "Eau",
    cat_ascenseur: "Ascenseur",
    cat_gardiennage: "Gardiennage",
    cat_nettoyage: "Nettoyage",
    cat_jardinage: "Jardinage",
    cat_reparations: "Réparations",
    cat_assurance: "Assurance",
    cat_syndic: "Syndic",
    cat_autres: "Autres",
    // ticket categories
    tcat_fuite: "Fuite d'eau",
    tcat_ascenseur: "Ascenseur",
    tcat_electricite: "Électricité",
    tcat_propreté: "Propreté",
    tcat_bruit: "Bruit",
    tcat_autre: "Autre",
    // status
    st_Nouveau: "Nouveau",
    st_Vu: "Vu",
    "st_En cours": "En cours",
    st_Resolu: "Résolu",
    currency: "DH",
    loading: "Chargement...",
    cancel: "Annuler",
    empty_generic: "Rien à afficher pour l'instant",
    access_denied: "Accès refusé — cette page est réservée au bureau.",
    pro_directory: "Annuaire des pros",
    pro_directory_sub: "Les artisans recommandés par vos voisins",
    add_pro: "Ajouter un pro",
    pro_name: "Nom / entreprise",
    pro_profession: "Métier",
    pro_phone: "Téléphone",
    pro_zone: "Ville / quartier",
    pro_note: "Pourquoi le recommandez-vous ?",
    pro_recommended_by: "Recommandé par",
    pro_call: "Appeler",
    pro_whatsapp: "WhatsApp",
    pro_rate: "Votre note",
    all_cat: "Tous",
    no_pros: "Aucun professionnel — soyez le premier à en recommander un !",
    reviews: "avis",
    neighbourhood_pick: "Recommandé par le quartier",
    delete: "Supprimer",
    prof_plomberie: "Plomberie",
    prof_electricite: "Électricité",
    prof_carrelage: "Carrelage",
    prof_peinture: "Peinture",
    prof_menuiserie: "Menuiserie",
    prof_climatisation: "Climatisation",
    prof_serrurerie: "Serrurerie",
    prof_macon: "Maçonnerie",
    prof_jardinage: "Jardinage",
    prof_nettoyage: "Nettoyage",
    prof_electromenager: "Électroménager",
    prof_autre: "Autre",
  },
  ar: {
    appName: "رحمة بلوك أ",
    appShort: "تدبير الإقامة",
    nav_home: "الرئيسية",
    nav_finances: "الحسابات",
    nav_action: "إجراء",
    nav_announcements: "إعلانات",
    nav_more: "المزيد",
    login: "دخول",
    logout: "خروج",
    email: "البريد الإلكتروني",
    login_title: "مرحبا بيك",
    login_subtitle: "دبّر إقامتك بكل شفافية",
    demo_badge: "إقامة تجريبية",
    demo_hint: "ولوج الديمو — تصفّح بحرية",
    demo_fill: "املأ ولوج الديمو",
    login_error: "البريد أو كلمة السر ماشي صحيحة",
    role_president: "الرئيس (النقيب)",
    role_tresorier: "أمين المال",
    role_conseil: "المجلس النقابي",
    role_coproprietaire: "مالك",
    role_gardien: "الحارس",
    hello: "السلام",
    balance: "رصيد الصندوق",
    reserve: "الاحتياطي المُجمّع",
    total_revenue: "مجموع المداخيل",
    total_expense: "مجموع المصاريف",
    cash: "نقدا",
    bank: "البنك",
    next_payment: "كراء الهوائي الجاي",
    available_funds: "الأموال المتوفرة",
    open_tickets: "طلبات مفتوحة",
    quick_actions: "إجراءات سريعة",
    report_problem: "بلّغ عن مشكل",
    add_expense: "زيد مصروف",
    emergency: "الطوارئ",
    pinned_announcements: "إعلانات مثبتة",
    recent_expenses: "آخر المصاريف",
    view_all: "شوف الكل",
    financial_health: "الوضعية المالية ديال العمارة",
    saved_this_period: "تقدّر",
    feed: "الأخبار",
    bank_account: "الحساب البنكي",
    antenna: "الهوائي",
    reports: "التقارير",
    transparency_feed: "سجل الشفافية",
    transparency_sub: "كل درهم، فالوقت الحقيقي",
    income: "مدخول",
    expense: "مصروف",
    receipt: "الوثيقة",
    view_receipt: "شوف الوثيقة",
    no_receipt: "ماكاينة وثيقة",
    ask_question: "طرح سؤال",
    questions: "أسئلة",
    your_question: "سؤالك على هاد المصروف",
    send: "صيفط",
    answer: "جاوب",
    cancelled: "ملغى",
    by: "من طرف",
    official_balance: "الرصيد الرسمي",
    statement_date: "تاريخ الكشف",
    updated_ago: "تحدّث فـ",
    reconciliation_ok: "المطابقة صحيحة — الرصيد كيطابق الكشف",
    reconciliation_warn: "فروقات خاصها تفسير",
    matched_ops: "عمليات مطابقة",
    unmatched: "فروقات",
    import_statement: "استورد كشف",
    operations: "عمليات الكشف",
    no_bank: "مازال ماكاين حتى كشف",
    antenna_contract: "عقد الهوائي",
    operator: "المشغّل",
    quarterly_amount: "الكراء الفصلي",
    contract_end: "نهاية العقد",
    payments_history: "تاريخ الأداءات",
    quarterly_summary: "ملخص فصلي",
    expenses_by_category: "المصاريف حسب النوع",
    generate_pdf: "تقرير PDF",
    quarter: "الفصل",
    action_title: "أش بغيتي دير؟",
    scan_invoice: "صوّر فاتورة",
    scan_sub: "صورة ← الذكاء الاصطناعي كيعمّر كلشي",
    ss_button: "الإيداع الذكي (ذكاء اصطناعي)",
    ss_button_sub: "صورة ولا سكان ← الذكاء الاصطناعي كيرتّب كلشي فبلاصتو",
    ss_title: "الإيداع الذكي",
    ss_drop: "صوّر ولا اختار ملف",
    ss_hint: "فاتورة، كشف بنكي، عقد، محضر… بالفرنسية ولا بالعربية",
    ss_pages_q: "واش زدتي گاع صفحات الوثيقة؟",
    ss_pages_hint: "زيد كل صفحة (مثلاً كشف بنكي فيه بزاف ديال الصفحات) قبل ما تبدا التحليل — الذكاء الاصطناعي غايقراهم گاع بحال وثيقة وحدة.",
    ss_add_page: "زيد صفحة",
    ss_all_added: "سالينا → حلّل",
    ss_pages_added: "وثيقة/صفحة مزادة",
    ss_single_pdf: "ملف PDF/CSV/Excel خاصو يتصيفط بوحدو. إلا كانو بزاف ديال الصفحات، استعمل التصاور.",
    doc_multi_hint: "بزاف ديال الصفحات؟ زيد كل تصويرة: غايتجمعو فـ PDF واحد.",
    ss_analyzing: "الذكاء الاصطناعي كيقرا الوثيقة ديالك…",
    ss_uploading: "كنصيفطو التصاور…",
    ss_dont_leave: "ما تخرجش من هاد الصفحة حتى يكمل التحليل، وإلا غادي تضيع التصاور ديالك.",
    ss_leave_confirm: "الذكاء الاصطناعي كيقرا التصاور ديالك دابا. إلا خرجتي دابا غادي تضيع هاد الوثيقة. تخرج على أي حال؟",
    ss_detected: "الوثيقة تعرّفات",
    ss_type_facture: "فاتورة / مصروف",
    ss_type_releve_bancaire: "كشف بنكي",
    ss_type_document: "وثيقة رسمية",
    ss_dest_facture: "غادي تسجّل فالمالية ← المصاريف (مع أرشفة الإثبات)",
    ss_dest_releve_bancaire: "غادي يتستورد فالمالية ← البنك مع مطابقة أوتوماتيكية",
    ss_dest_document: "غادي تترتّب فمكتبة الوثائق",
    ss_wrong_type: "ماشي النوع الصحيح؟ صحّح :",
    ss_confirm: "أكّد ورتّب",
    ss_saved_facture: "المصروف تسجّل فالمالية",
    ss_saved_releve_bancaire: "الكشف تستورد — المطابقة دارت",
    ss_saved_document: "الوثيقة ترتّبات فالمكتبة",
    ss_view: "شوف النتيجة",
    ss_scan_more: "صوّر وثيقة أخرى",
    ss_tx_count: "عملية تكتاشفات",
    ss_statement_date: "تاريخ الكشف",
    ss_closing_balance: "الرصيد النهائي (درهم)",
    ss_matched: "تطابقات",
    ss_anomalies: "شذوذات",
    ss_analyze_failed: "الذكاء الاصطناعي ماقدرش يقرا هاد الوثيقة. عاود بصورة أوضح.",
    ss_amount_required: "المبلغ ضروري",
    ss_title_required: "العنوان ضروري",
    ss_type_rib: "RIB بنكي",
    ss_dest_rib: "غادي يترتّب فالمالية ← البنك ← RIB (الرئيس وأمين المال)",
    ss_saved_rib: "الـRIB تسجّل فالمالية ← البنك",
    ss_rib_required: "رقم الـRIB ضروري",
    ss_bank_required: "تاريخ الكشف والرصيد النهائي ضروريين",
    rib_kind_residence: "RIB ديال الإقامة",
    rib_kind_externe: "RIB آخر (مزوّد…)",
    rib_label: "التسمية (مثلاً: سمية المزوّد)",
    rib_holder: "صاحب الحساب",
    rib_bank: "البنك",
    rib_agency: "الوكالة",
    rib_number: "رقم RIB (24 رقم)",
    rib_iban: "IBAN (اختياري)",
    rib_residence: "RIB ديال الإقامة",
    rib_externes: "RIB مسجّلين (مزوّدين…)",
    rib_copy: "نسخ",
    rib_copied: "الـRIB تنسخ",
    copy_failed: "ما قدرناش ننسخو",
    load_failed: "ما قدرناش نحمّلو المعطيات. تأكد من الاتصال ديالك.",
    bkp_title: "النسخ الاحتياطي",
    bkp_sub: "نسخة كاملة مشفّرة + استرجاع",
    bkp_need_password: "أول حاجة، حدّد كلمة سر ديال التشفير",
    bkp_password_hint: "كتحمي النسخ ديالك. بلاها ما يمكن حتى نسخة.",
    bkp_set_password: "حدّد كلمة السر",
    bkp_password_warn: "⚠️ سجّلها مزيان: ضرورية باش ترجّع. حتى واحد ما يقدر يستخرجها.",
    bkp_password_ph: "كلمة سر التشفير",
    bkp_password_confirm: "أكّد كلمة السر",
    bkp_password_min: "على الأقل 8 حروف",
    bkp_password_mismatch: "كلمات السر ما متطابقاش",
    bkp_last: "آخر نسخة",
    bkp_never: "مازال والو",
    bkp_run_now: "دير نسخة دابا",
    bkp_running: "كنسخو…",
    bkp_done: "تسالت النسخة ✓",
    bkp_done_with_errors: "تدارت النسخة، ولكن شي إرسال فشل (شوف السجل)",
    bkp_failed: "فشلات العملية",
    bkp_daily: "نسخة تلقائية كل يوم",
    bkp_hour: "الساعة",
    bkp_retention: "نحتافظو (عدد)",
    bkp_schedule_hint: "كل يوم فالساعة المختارة (توقيت المغرب). كنحتافظو بآخر N، والقدام كيتمسحو.",
    bkp_destinations: "الوجهات",
    bkp_dest_hint: "صيفط كل نسخة لواحد ولا بزاف ديال التخزينات الخارجية. عمّر معطيات الاتصال.",
    bkp_disabled: "مطفّية",
    bkp_test: "اختبر",
    bkp_testing: "اختبار الاتصال…",
    bkp_test_ok: "الاتصال نجح ✓",
    bkp_test_fail: "ما تقدرش الاتصال",
    bkp_dest_delete_confirm: "تمسح هاد الوجهة؟",
    bkp_dest_label: "الاسم (مثلا: Glacier ديالي)",
    bkp_folder: "مجلد / بادئة (اختياري)",
    bkp_s3_endpoint: "Endpoint (خاويّة = AWS ؛ ولا Wasabi/B2/MinIO)",
    bkp_az_account: "اسم حساب التخزين",
    bkp_az_key: "مفتاح الحساب",
    bkp_sftp_user: "المستخدم",
    bkp_sftp_dir: "المجلد البعيد (مثلا: /volume1/backups)",
    bkp_sftp_pw: "كلمة السر",
    bkp_secret_keep: "(خليها خاوية = ما تتبدلش)",
    bkp_history: "السجل",
    bkp_none: "مازال ما كاين نسخ",
    bkp_files: "ملفات",
    bkp_records: "سجلات",
    bkp_collections: "أقسام",
    bkp_kind_manual: "يدوية",
    bkp_kind_auto: "تلقائية",
    bkp_kind_pre_restore: "قبل الاسترجاع",
    bkp_restore: "رجّع",
    bkp_restore_from_file: "رجّع من ملف",
    bkp_restore_file_hint: "اختار أرشيف .zip محمّل ودخّل كلمة السر ديالو. مفيد إلا تلف السيرفر ولا تهاكر.",
    bkp_choose_file: "اختار ملف",
    bkp_delete_confirm: "تمسح هاد النسخة؟",
    bkp_restore_confirm1: "الاسترجاع غادي يعوّض گاع المعطيات الحالية بمعطيات هاد النسخة. نكمّلو؟",
    bkp_restore_confirm2: "واش متأكد بزاف؟ غادي تتدار نسخة أمان قبل.",
    bkp_restoring: "كنرجّعو…",
    bkp_restored: "تسالا الاسترجاع ✓",
    bkp_bad_password: "كلمة السر غالطة لهاد الأرشيف",
    wipe_zone_title: "منطقة الخطر",
    wipe_title: "مسح جميع البيانات",
    wipe_desc: "كيمسح نهائياً جميع البيانات (المصاريف، المداخيل، الطلبات، الإعلانات، الوثائق، الجموع العامة، المساهمات، حسابات الأعضاء الآخرين…). كيحتافظ غير بالحساب ديالك، العمارة والشقق (مرجوعين خاويين).",
    wipe_backup_first: "دير نسخة احتياطية فوق الأول إلا بغيتي تقدر ترجّع كلشي.",
    wipe_button: "مسح جميع البيانات",
    wipe_modal_title: "تمسح جميع البيانات؟",
    wipe_warn: "إجراء لا رجعة فيه. غادي يتمسحو: جميع بيانات الإقامة وجميع الحسابات ماعدا ديالك. النسخ الاحتياطية كتبقى محفوظة.",
    wipe_kept: "الحساب المحتافظ بيه",
    wipe_confirm_label: "باش تأكّد، كتب SUPPRIMER بحروف كبيرة:",
    wipe_confirm_ph: "SUPPRIMER",
    wipe_confirm_mismatch: "كتب بالضبط SUPPRIMER باش تأكّد",
    wipe_running: "كيتمسح…",
    wipe_done: "تمسحو البيانات — الإقامة واجدة للانطلاق ✓",
    wipe_items: "عنصر تمسح",
    rib_delete_confirm: "نحيد هاد الـRIB؟",
    occ_label: "شكون ساكن فالشقة؟",
    occ_occupant: "أنا ساكن فيها",
    occ_loue: "مكراة لمكتري",
    occ_tenant_name: "سمية المكتري (اختياري)",
    occ_tenant_phone: "تيليفون المكتري (اختياري)",
    occ_why: "علاش هاد المعلومات؟ فحالة مشكل مستعجل فالعمارة (تسرب الما، حريق، ضرر…)، خاص النقيب يقدر يتواصل بسرعة مع اللي ساكن فعلياً فالشقة. ما كيتشاركو غير بموافقتك.",
    lot_occupant_badge: "المالك ساكن فيها",
    lot_tenant: "المكتري",
    lot_ask_tenant: "شوف معلومات المكتري (بموافقة المالك)",
    lot_request_pending: "الطلب تصيفط — فانتظار موافقة المالك",
    lot_request_sent: "الطلب تصيفط للمالك",
    recon_to_revenue: "سجّل كمدخول",
    recon_to_revenue_done: "المدخول تسجّل — الخزينة تحدّثات",
    ant_title: "عقد الهوائي",
    ant_operator: "المشغّل",
    ant_quarterly: "الكراء الفصلي (درهم)",
    ant_start: "بداية العقد",
    ant_end: "نهاية العقد (اختياري)",
    ant_contact: "جهة الاتصال ديال المشغّل (اختياري)",
    ant_next_due: "الدفعة الجاية المنتظرة",
    ant_overdue: "الدفعة متأخرة !",
    ant_last_payment: "آخر دفعة",
    ant_setup: "إعداد عقد الهوائي",
    ant_required: "الكراء الفصلي وتاريخ البداية ضروريين",
    welcome_title: "مرحبا بيك فدارك",
    welcome_sub: "هاد الفضاء ديالك : كلشي على الإقامة، بكل شفافية.",
    welcome_f1: "تبّع كل مصروف مع الإثبات ديالو، الرصيد فالبنك والتقارير.",
    welcome_f2: "عندك مشكل فالعمارة؟ صرّح بيه ف30 ثانية (تسرب، سانسور، نظافة…).",
    welcome_f3: "شوف الوثائق الرسمية وصوّت فالجموع العامة.",
    welcome_f4: "فالبروفيل ديالك، وضّح واش ساكن فالشقة ولا مكرية — مفيد فحالة مشكل مستعجل.",
    welcome_cta: "يالله نبداو",
    reg_lang_label: "اللغة ديالك",
    reg_lang_hint: "الموقع والإيميلات غادي يكونو بهاد اللغة. تقدر تبدّلها فأي وقت بالزر اللي فوق فالشاشة.",
    take_photo: "صوّر / اختار صورة",
    analyzing: "الذكاء الاصطناعي كيحلّل...",
    supplier: "المزوّد",
    amount: "المبلغ (درهم)",
    vat: "الضريبة (درهم)",
    date: "التاريخ",
    category: "النوع",
    account: "الحساب",
    note: "ملاحظة",
    save: "سجّل",
    saved: "تسجّل",
    add_revenue: "سجّل كراء الهوائي",
    tickets: "الطلبات والأعطاب",
    new_ticket: "طلب جديد",
    ticket_category: "النوع",
    description: "الوصف",
    location: "المكان (الطابق/المنطقة)",
    status: "الحالة",
    create: "إنشاء",
    my_tickets: "طلباتي الجارية",
    no_tickets: "ماكاين حتى طلب — كلشي مزيان فالإقامة",
    assigned_to: "مسند لـ",
    comment: "تعليق",
    announcements: "الإعلانات",
    new_announcement: "إعلان جديد",
    title: "العنوان",
    message: "الرسالة",
    pin: "تثبيت",
    no_announcements: "ماكاين حتى إعلان",
    building: "العمارة والشقق",
    residents: "السكان",
    residents_sub: "احترام الخصوصية — المعلومات بعد الموافقة",
    apartment: "الشقة",
    you_tag: "أنت",
    request_contact: "اطلب معلومات الاتصال",
    request_sent: "تم إرسال الطلب",
    incoming_requests: "طلبات واردة",
    wants_contact: "بغى يشوف معلومات الاتصال ديالك",
    authorize: "موافقة",
    refuse: "رفض",
    privacy_note: "احتراما للخصوصية، كيبان غير الاسم الأول والحرف الأول واللقب ورقم الشقة.",
    contact_visible: "المعلومات متبادلة",
    ideas: "صندوق الأفكار",
    ideas_sub: "اقترح، صوّت، نحسّنو الإقامة مع بعضياتنا",
    new_idea: "اقترح فكرة",
    idea_title: "عنوان الفكرة",
    idea_desc: "وصف الفكرة ديالك",
    visibility: "الظهور",
    vis_public: "يشوفها الجميع",
    vis_prive: "خاص (الرئيس وأمين المال)",
    support: "كنساند",
    supported: "مساند",
    supports: "مساندة",
    no_ideas: "ماكاين حتى فكرة — كون أول واحد!",
    private_idea: "خاص",
    ist_nouvelle: "جديدة",
    ist_etude: "قيد الدراسة",
    ist_retenue: "مقبولة",
    ist_refusee: "مرفوضة",
    auto_translated: "ترجمة تلقائية",
    show_original: "شوف النص الأصلي",
    show_translation: "شوف الترجمة",
    translation_hint: "ترجمة تلقائية — إلى كان عندك شك، تواصل مع صاحب النص.",
    documents: "الوثائق",
    documents_sub: "النظام الداخلي، العقود والوثائق الرسمية ديال الإقامة",
    doc_reglement: "النظام الداخلي للملكية المشتركة",
    doc_contrat: "عقود المزوّدين",
    doc_legal: "الوثائق القانونية",
    doc_pv: "محاضر الجمع العام",
    doc_attestation: "الشهادات",
    doc_facture: "فواتير مهمة",
    doc_autre: "أخرى",
    add_document: "زيد وثيقة",
    edit_document: "تعديل",
    doc_title: "عنوان الوثيقة",
    doc_description: "وصف (اختياري)",
    doc_body: "نص النظام الداخلي",
    doc_body_ph: "كتب أو الصق نص النظام الداخلي…",
    doc_category: "النوع",
    doc_supplier: "المزوّد",
    doc_service_type: "نوع الخدمة (المصعد، التنظيف…)",
    doc_start: "البداية",
    doc_end: "النهاية",
    doc_amount: "المبلغ السنوي (درهم)",
    doc_file: "ملف (PDF أو صورة)",
    choose_file: "اختار ملف / سكان",
    take_photo_cam: "صوّر بالكاميرا",
    consult: "طالع",
    download: "حمّل",
    no_documents: "ماكاينة حتى وثيقة فهاد النوع",
    download_restricted: "غير الرئيس وأمين المال يقدرو يحمّلو الملفات.",
    file_attached: "ملف مرفق",
    uploading: "جاري الإرسال…",
    ongoing: "جارٍ",
    doc_vis_public: "يشوفها الجميع",
    doc_vis_bureau: "خاص بالمكتب",
    doc_private_badge: "المكتب",
    quarterly_report: "التقرير المالي الفصلي",
    report_period: "اختار الفصل",
    download_report: "حمّل PDF",
    share_whatsapp: "شارك واتساب",
    wa_alert: "نبّه واتساب",
    wa_report_footer: "التفاصيل الكاملة فالتطبيق Rahma Bat A — شفافية تامة فالحسابات.",
    treasury_total: "مجموع الخزينة",
    cash_box: "الصندوق",
    cash_box_full: "الصندوق النقدي (عند أمين المال)",
    bank_balance_label: "الرصيد البنكي",
    advances_due: "تسبيقات خاص ترجّع",
    pending_expenses: "فانتظار الخلاص",
    cash_movements: "حركات الصندوق",
    no_movements: "ماكاينة حتى حركة فالصندوق",
    add_withdrawal: "سحب من البنك ← الصندوق",
    withdrawal_amount: "المبلغ المسحوب (درهم)",
    withdrawal_label: "الوصف (البنك، السبب…)",
    record_withdrawal: "سجّل السحب",
    mov_withdrawal: "سحب بنكي",
    mov_expense: "خلاص فاتورة",
    mov_reimbursement: "إرجاع تسبيق",
    payment: "الخلاص",
    payment_status_label: "حالة الخلاص",
    pay_pending: "فانتظار",
    pay_paid: "مخلّصة",
    payment_method_label: "طريقة الخلاص",
    pm_cash: "نقدا (الصندوق)",
    pm_bank: "تحويل / بنك",
    pm_advance: "تسبيق (فلوس شخصية)",
    pay_now: "خلّص",
    choose_pay_method: "خلّص المصروف",
    reimburse_now: "رجّع",
    reimburse_title: "رجّع التسبيق",
    badge_pending: "فانتظار",
    badge_cash: "مخلّصة نقدا",
    badge_bank: "مخلّصة بنك",
    badge_advance: "تسبيق خاص يترجّع",
    badge_reimbursed: "مرجوعة",
    advanced_by_label: "تسبّق من طرف",
    pay_advanced: "تسبّق بها…",
    advance_by_select: "شكون سبّق الفلوس؟",
    advance_confirm_label: "أكّد هاد الاسم",
    advance_confirmed: "الاسم مأكّد",
    advance_select_required: "اختار شكون سبّق الفلوس",
    advance_confirm_required: "أكّد اسم الشخص اللي سبّق الفلوس",
    advances_recap_title: "تسبيقات خاصها تترجّع",
    advances_recap_sub: "المجموع اللي خاص يترجّع لكل واحد — باش ما ننساو والو",
    advances_none: "ما كاين حتى تسبيق باقي ما ترجّع",
    advances_grand_total: "المجموع الكامل للترجيع",
    advance_invoices: "فاتورة",
    reimburse_person_confirm: "تأكيد الترجيع",
    reimburse_person_msg: "غادي ترجّع",
    to_person: "لـ",
    reimburse_method_hint: "إلا خلّصتي نقدا، المبلغ غادي يتخصم من الصندوق.",
    confirm_btn: "أكّد",
    justif_required: "زيد أولا الإثبات (تصويرة/سكان) باش تسجّل تسبيق",
    cash_only_tresorier: "غير أمين المال يقدر يخلّص نقدا",
    topup_title: "تمويل الصندوق",
    topup_sub: "سحب بنكي ← نقدا (مصادقة مزدوجة)",
    topup_amount: "مبلغ السحب (درهم)",
    topup_label: "البنك / الوصف",
    topup_proof: "إثبات السحب (تصويرة/سكان)",
    topup_proof_required: "زيد إثبات السحب",
    request_topup: "اطلب التمويل",
    topups_history: "تمويلات الصندوق",
    topup_pending: "فانتظار المصادقة",
    topup_valid: "مصادَق عليها",
    topup_refused: "مرفوضة",
    awaiting_president: "فانتظار الرئيس",
    approve: "صادق",
    reject: "ارفض",
    reject_reason: "سبب الرفض",
    requested_by: "طلبها",
    validated_by: "صادق عليها",
    double_val_note: "كل تمويل خاصو مصادقة أمين المال والرئيس بجوج.",
    notifications: "الإشعارات",
    no_notifications: "ماكاين حتى إشعار",
    push_settings: "الإشعارات (Push)",
    push_enable: "فعّل الإشعارات",
    push_enable_desc: "توصل بالتنبيهات المهمة (المصادقات، الأخطاء، الإعلانات) حتى فاش التطبيق مسدود.",
    push_activate: "فعّل",
    push_later: "من بعد",
    push_on: "الإشعارات مفعّلة",
    push_off: "الإشعارات مطفّية",
    push_enabled_toast: "الإشعارات تفعّلات 🔔",
    push_disabled_toast: "الإشعارات تطفّات",
    push_denied: "الإشعارات محجوبة فإعدادات المتصفّح.",
    push_unsupported: "المتصفّح ديالك ما كيدعمش إشعارات push.",
    push_test: "صيفط تجربة",
    push_test_sent: "تصيفط إشعار تجريبي",
    push_ios_hint: "فالآيفون: زيد التطبيق للشاشة الرئيسية أوّلاً (مشاركة ← زيد للشاشة الرئيسية)، من بعد فعّل الإشعارات.",
    mark_all_read: "علّم الكل كمقروء",
    statement_imported: "الكشف تسجّل وتمّت المطابقة",
    reconciling: "المطابقة بالذكاء الاصطناعي…",
    recon_engine_ai: "مطابقة بالذكاء الاصطناعي",
    recon_engine_algo: "مطابقة تلقائية",
    recon_matches: "التطابقات",
    recon_anomalies: "فروقات خاصها معالجة",
    recon_bank_only: "فالكشف، غير موجودة فالتطبيق",
    recon_app_only: "فالتطبيق، غير موجودة فالكشف",
    recon_resolve: "حل / تعليق",
    recon_mark_resolved: "علّمها محلولة",
    recon_resolved: "الفرق تحلّ",
    recon_resolved_plural: "فروقات محلولة",
    recon_resolved_by: "حلّها",
    recon_reopen: "إعادة فتح",
    recon_comment_ph: "فسّر هاد الفرق (مثلا: تحويل فانتظار، مصاريف بنكية…)",
    recon_comment_required: "زيد تعليق باش تحل الفرق",
    recon_open_count: "فروقات مفتوحة",
    recon_accept_all: "قبول الكل",
    recon_accept_all_confirm: "تعليم جميع الفروقات المفتوحة كمقبولة؟ مفيد باش تصفّي بسرعة كشف قديم بلا ما تعلّق عليهم وحدة بوحدة.",
    recon_accept_all_done: "تقبلات الفروقات",
    recurring_label_suggest: "مصروف متكرر؟ اقتراح التسمية",
    recurring_label_use: "استعمل",
    login_id_ph: "السمية.الحرف (مثلا: karim.b)",
    login_pin_ph: "كود PIN (من 4 ل 6 أرقام)",
    login_remember: "بقى متصل فهاد الجهاز",
    forgot_identifier: "نسيتي المعرف؟",
    forgot_pin: "نسيتي كود PIN؟",
    have_invite: "عندي كود دعوة",
    forgot_sent: "الرئيس تبلّغ",
    forgot_pin_help: "دخّل المعرف ديالك: الرئيس غادي يتبلّغ وغادي يعاود يعيّن الكود.",
    forgot_identifier_help: "دخّل رقم التيليفون: الرئيس غادي يعاود يصيفط ليك المعرف.",
    phone_ph: "رقم التيليفون",
    notify_president: "بلّغ الرئيس",
    back: "رجوع",
    continue: "كمّل",
    activation_title: "تفعيل الحساب",
    activation_step0_help: "دخّل المعرف وكود الدعوة اللي توصلتي بيهم فواتساب.",
    invite_code_ph: "كود الدعوة (مثلا: K7M2PA)",
    choose_pin: "ختار كود PIN",
    pin_rule: "كود من 4 ل 6 أرقام، اللي تختارو نتا.",
    confirm_pin: "أكّد كود PIN",
    pin_mismatch: "كودات PIN ماكيتطابقوش",
    change_pin: "بدّل كود PIN ديالي",
    change_pin_title: "بدّل كود PIN ديالك",
    change_pin_required_title: "خاصك تبدّل كود PIN",
    change_pin_required_sub: "من أجل أمانك، ختار كود PIN شخصي جديد قبل ما تكمّل.",
    change_pin_ok: "كود PIN تبدّل",
    change_pin_cta: "أكّد الكود الجديد",
    current_pin_label: "كود PIN الحالي",
    new_pin_label: "كود PIN الجديد",
    confirm_pin_label: "أكّد الكود الجديد",
    pin_need_6: "كود PIN خاصو يكون 6 أرقام",
    pin_policy_hint: "6 أرقام. بعّد على السلاسل (123456) والأرقام المتشابهة (000000).",
    session_expired_inactive: "انتهات الجلسة بسبب عدم النشاط. عاود دخل.",
    session_expiring_title: "الجلسة قربات تسالي",
    session_expiring_msg: "غادي يتقطع عليك الاتصال بسبب عدم النشاط.",
    stay_connected: "بقى متصل",
    complete_profile: "كمّل الملف ديالك",
    profile_help: "هاد المعلومات كتعمّر دليل السكان.",
    full_name: "الاسم الكامل",
    apartment_label: "رقم الشقة",
    finish_activation: "فعّل الحساب",
    activation_done: "الحساب تفعّل!",
    activation_done_help: "مرحبا بيك. دابا نتا متصل.",
    directory_notice: "فالدليل، الجيران كيشوفو غير الشقة والسمية والحرف الأول. المعلومات ديالك ماكتبانش حتى تقبل طلب تواصل.",
    enter_app: "دخل للتطبيق",
    profile_required: "جميع خانات الملف إجبارية",
    user_management: "تدبير المستخدمين",
    add_user: "زيد",
    role_requests: "مصادقات فانتظار",
    awaiting_treasurer: "فانتظار الخازن",
    apt: "شقة",
    status_active: "نشيط",
    status_invited: "فانتظار",
    status_disabled: "موقّف",
    invite_code: "كود الدعوة",
    send_whatsapp: "دعوة عبر واتساب",
    regenerate_code: "كود جديد",
    edit: "تعديل",
    reset_pin: "إعادة تعيين PIN",
    enable: "تفعيل",
    disable: "توقيف",
    reset_pin_confirm: "إعادة تعيين كود PIN ديال هاد المستخدم؟ غادي يتصاوب كود دعوة جديد.",
    pin_reset_done: "PIN تعاود تعيّن — صيفط الكود الجديد",
    code_regenerated: "كود جديد تصاوب",
    role_approved_toast: "التغيير تصادق عليه",
    role_rejected_toast: "التغيير مترفض",
    name_required: "السمية إجبارية",
    user_created: "الحساب تصاوب — صيفط الدعوة",
    identifier_optional: "المعرف (خليه خاوي = تلقائي)",
    email_invite_optional: "الإيميل (اختياري — كيصيفط الدعوة بالإيميل)",
    email_section: "الإيميلات",
    email_configured: "إرسال الإيميلات مفعّل",
    email_not_configured: "الإيميل مازال ماتكونفيگاش",
    email_test_btn: "صيفط إيميل تجريبي",
    email_test_ok: "تصيفط إيميل تجريبي",
    create_account: "صاوب حساب",
    have_account: "عندي ديجا حساب",
    register_title: "صاوب حسابي",
    register_subtitle: "تسجّل، أكّد الإيميل ديالك، من بعد النقيب يصادق على الولوج ديالك.",
    reg_name_ph: "الاسم الكامل",
    reg_apartment_label: "السكن ديالك",
    reg_select_apartment: "اختار السكن ديالك",
    reg_phone_ph: "التيليفون (واتساب)",
    reg_email_ph: "الإيميل",
    reg_pin_ph: "اختار كود PIN (4 حتى 6 أرقام)",
    reg_pin_confirm_ph: "أكّد كود PIN",
    reg_pin_mismatch: "كود PIN ماكيتطابقش",
    reg_fields_required: "عمّر جميع الخانات عافاك",
    reg_choose_residence: "اختار الإقامة ديالك الأول.",
    register_submit: "سجّلني",
    register_success_title: "شوف الإيميل ديالك 📬",
    register_success_msg: "صيفطنا ليك رابط ديال التأكيد. كليكي عليه باش تأكّد الإيميل، من بعد تسنّى مصادقة النقيب.",
    back_to_login: "رجع للدخول",
    verify_checking: "كنأكّدو…",
    verify_success_title: "الإيميل تأكّد ✅",
    verify_success_msg: "شكرا! الطلب ديالك تصيفط للنقيب. غادي تقدر تدخل منين يصادق على الحساب ديالك.",
    verify_already_active: "الحساب ديالك ديجا مفعّل. تقدر تدخل.",
    verify_error_title: "الرابط ماصالحش",
    verify_error_msg: "هاد الرابط ديال التأكيد ماصالحش ولا سالا الوقت ديالو. عاود التسجيل.",
    pending_registrations: "تسجيلات فانتظار",
    no_pending_registrations: "ماكاين حتى تسجيل فانتظار.",
    rejected_history: "تسجيلات مرفوضة",
    awaiting_email_confirm: "فانتظار تأكيد الإيميل من طرف الساكن.",
    approve_registration: "صادق على التسجيل",
    registration_approved: "التسجيل تصادق عليه",
    registration_rejected_toast: "التسجيل مرفوض",
    reject_registration_confirm: "ترفض هاد التسجيل؟",
    active_members: "الأعضاء النشطين",
    status_pending_email: "خاص تأكيد الإيميل",
    status_pending_approval: "خاص المصادقة",
    status_rejected: "مرفوض",
    role_label: "الدور",
    lang_label: "اللغة المفضلة",
    lang_name_fr: "الفرنسية",
    lang_name_ar: "الدارجة",
    lang_name_en: "الإنجليزية",
    create_user: "صاوب الحساب",
    suggested_id: "المعرف المقترح",
    treasurer_4eyes_note: "تبديل الخازن كيتطلب مصادقة الخازن الخارج (قاعدة 4 عيون).",
    force_reason_ph: "السبب إلا الخازن ماكانش متاح (فرض مسجّل)",
    role_pending: "خاص مصادقة الخازن",
    profile_updated: "الملف تحدّث",
    edit_profile: "عدّل الملف ديالي",
    sans_facture_toggle: "مزوّد بلا فاتورة",
    sans_facture_hint: "بعض الصنّاع ما كيعطيوش فاتورة. عمّر جميع الخانات لتحت.",
    artisan_name: "اسم الصانع / المقاولة",
    artisan_phone: "هاتف الصانع",
    service_desc: "وصف الخدمة",
    intervention_at: "تاريخ ووقت التدخل",
    sans_facture_badge: "بلا فاتورة — صانع مُصرّح به",
    proof_ok: "الإثبات مضاف",
    add_proof: "زيد الإثبات",
    providers: "المزوّدون",
    profile: "حسابي",
    settings: "الإعدادات",
    language: "اللغة",
    dark_mode: "الوضع الليلي",
    audit_log: "سجل العمليات",
    lots: "الشقق",
    lot_number: "رقم الشقة",
    duplex: "دوبلكس",
    duplexes: "دوبلكس",
    the_building: "العمارة",
    entrance: "المدخل الرئيسي",
    dwellings: "سكنات",
    assemblies: "الجموع العامة",
    ag_new: "جمع عام جديد",
    ag_none: "ماكاين حتى جمع عام دابا.",
    ag_ordinaire: "عادي",
    ag_extraordinaire: "استثنائي",
    ag_status_brouillon: "مسودة",
    ag_status_convoquee: "متبلّغ بيه",
    ag_status_vote_ouvert: "التصويت مفتوح",
    ag_status_cloturee: "مسدود",
    ag_title_label: "عنوان الجمع",
    ag_title_required: "دخّل عنوان الجمع",
    ag_kind: "النوع",
    ag_datetime: "التاريخ والوقت",
    ag_place: "المكان",
    ag_quorum_required: "النصاب",
    ag_agenda: "جدول الأعمال",
    ag_add_item: "زيد",
    ag_item_title: "عنوان القرار",
    ag_item_desc: "الوصف (اختياري)",
    ag_requires_vote: "خاضع للتصويت",
    ag_info_point: "نقطة إخبارية (بلا تصويت)",
    ag_create: "أنشئ الجمع",
    ag_created: "تنشأ الجمع العام",
    ag_convene: "بلّغ بالجمع",
    ag_convened: "تبلّغ بالجمع — الجميع توصل",
    ag_open_vote: "افتح التصويت",
    ag_opened: "التصويت مفتوح",
    ag_close_vote: "سدّ وانشر النتائج",
    ag_closed: "تسدّ الجمع — النتائج تنشرو",
    ag_confirm_close: "تسدّ التصويت وتنشر النتائج؟",
    ag_delete: "حيّد",
    ag_deleted: "تحيّد الجمع",
    ag_confirm_delete: "تحيّد هاد الجمع؟",
    ag_share_convocation: "شارك الاستدعاء",
    ag_share_results: "شارك النتائج",
    ag_download_pv: "حمّل المحضر (PDF)",
    ag_participation: "المشاركة",
    ag_quorum_reached: "النصاب متحقق",
    ag_quorum_not_reached: "النصاب ماشي متحقق",
    ag_my_weight: "وزن التصويت ديالك",
    ag_vote_pour: "مع",
    ag_vote_contre: "ضد",
    ag_vote_abstention: "امتناع",
    ag_submit_vote: "سجّل التصويت ديالي",
    ag_voted: "تسجّل التصويت",
    ag_cannot_vote: "غير الملاك كيصوتو (حسب التانتيام ديالهم).",
    ag_adopted: "مقبولة",
    ag_rejected: "مرفوضة",
    maintenance: "دفتر الصيانة",
    legal: "الإطار القانوني",
    cotisations: "المساهمات",
    cotisations_sub: "طلبات الأموال مقسّمة على الملاك",
    cot_new: "طلب جديد",
    cot_none: "ماكاين حتى طلب أموال دابا.",
    cot_kind_ordinaire: "عادي",
    cot_kind_travaux: "أشغال",
    cot_kind_exceptionnel: "استثنائي",
    cot_title_label: "موضوع الطلب (مثال: مصاريف الفصل 3)",
    cot_title_required: "دخّل موضوع الطلب",
    cot_amount_required: "دخّل مبلغ إجمالي صحيح",
    cot_period: "الفترة",
    cot_period_ph: "الفترة (مثال: الفصل 3 2026)",
    cot_method: "التوزيع",
    cot_method_tantiemes: "حسب الأنصبة (التانتيام)",
    cot_method_equal: "بالتساوي",
    cot_method_hint: "حسب الأنصبة: المبلغ كيتقسّم حسب تانتيام كل شقة. بالتساوي: المبلغ كيتقسّم بالتساوي على جميع الشقق.",
    cot_total: "المبلغ الإجمالي (درهم)",
    cot_due: "أجل الأداء",
    cot_note: "ملاحظة (اختياري)",
    cot_create: "أصدر الطلب",
    cot_created: "تصدّر طلب الأموال",
    cot_status_open: "جارٍ",
    cot_status_closed: "مسدود",
    cot_collected: "المُحصّل",
    cot_outstanding: "الباقي للتحصيل",
    cot_paid_lots: "خالصين",
    cot_charges: "الأنصبة حسب الشقة",
    cot_lot: "شقة",
    cot_amount_due: "المبلغ المطلوب",
    cot_remaining: "الباقي",
    cs_unpaid: "ماخالصةش",
    cs_partial: "جزئية",
    cs_paid: "مخلّصة",
    cot_pay: "سجّل الخلاص",
    cot_pay_title: "سجّل أداء",
    cot_pay_amount: "المبلغ (خاوي = الباقي كامل)",
    cot_pay_date: "تاريخ الأداء",
    cot_pay_note: "ملاحظة (اختياري)",
    cot_pay_submit: "أكّد الأداء",
    cot_paid_ok: "الأداء تسجّل",
    cot_receipt: "وصل PDF",
    cot_reset: "إلغاء",
    cot_reset_confirm: "تلغي جميع أداءات هاد النصيب؟",
    cot_reset_ok: "الأداءات تلغات",
    cot_close: "سدّ",
    cot_reopen: "عاود افتح",
    cot_closed_ok: "الطلب تسدّ",
    cot_reopen_ok: "الطلب تعاود فتح",
    cot_delete: "حذف",
    cot_delete_confirm: "تحيّد هاد طلب الأموال وجميع الأنصبة ديالو؟",
    cot_deleted: "الطلب تحيّد",
    cot_impayes: "غير المخلّصين",
    cot_impayes_total: "المجموع للتحصيل",
    pmth_cash: "نقدا",
    pmth_bank: "تحويل / بنك",
    pmth_cheque: "شيك",
    mnt_new: "تدخّل جديد",
    mnt_edit: "عدّل التدخّل",
    mnt_none: "ماكاين حتى تدخّل مسجّل.",
    mnt_cat_ascenseur: "المصعد",
    mnt_cat_etancheite: "العزل (السطح)",
    mnt_cat_extincteurs: "مطافئ الحريق",
    mnt_cat_plomberie: "السباكة",
    mnt_cat_electricite: "الكهرباء",
    mnt_cat_nettoyage: "التنظيف",
    mnt_cat_espaces_verts: "المساحات الخضراء",
    mnt_cat_autre: "أخرى",
    mnt_title: "عنوان التدخّل",
    mnt_title_required: "دخّل عنوان التدخّل",
    mnt_desc: "الوصف (اختياري)",
    mnt_provider: "المزوّد",
    mnt_phone: "الهاتف",
    mnt_date: "تاريخ الإنجاز",
    mnt_cost: "التكلفة",
    mnt_next_due: "الاستحقاق القادم",
    mnt_status: "الحالة",
    mnt_status_fait: "منجزة",
    mnt_status_planifie: "مبرمجة",
    mnt_upcoming: "الاستحقاقات القادمة",
    mnt_overdue: "متأخرة",
    mnt_due_soon: "قريباً",
    mnt_save: "سجّل",
    mnt_created: "تزاد التدخّل",
    mnt_updated: "تعدّل التدخّل",
    mnt_deleted: "تحيّد التدخّل",
    mnt_confirm_delete: "تحيّد هاد التدخّل؟",
    rented: "مكترى",
    floor: "الطابق",
    surface: "المساحة",
    tantiemes: "الأنصبة",
    owner: "المالك",
    common_areas: "الأجزاء المشتركة",
    ca_hall: "المدخل (الهول)",
    ca_escaliers: "الدروج",
    ca_paliers: "البسطات",
    ca_toit: "السطح (سطح)",
    ca_ascenseur: "المصعد",
    ca_loge: "بيت الحارس",
    manage_users: "تدبير المستخدمين",
    cat_electricite: "الكهرباء",
    cat_eau: "الماء",
    cat_ascenseur: "المصعد",
    cat_gardiennage: "الحراسة",
    cat_nettoyage: "التنظيف",
    cat_jardinage: "البستنة",
    cat_reparations: "الإصلاحات",
    cat_assurance: "التأمين",
    cat_syndic: "التسيير",
    cat_autres: "أخرى",
    tcat_fuite: "تسرّب الماء",
    tcat_ascenseur: "المصعد",
    tcat_electricite: "الكهرباء",
    tcat_propreté: "النظافة",
    tcat_bruit: "الضجيج",
    tcat_autre: "أخرى",
    st_Nouveau: "جديد",
    st_Vu: "تمت المشاهدة",
    "st_En cours": "قيد الإنجاز",
    st_Resolu: "تم الحل",
    currency: "درهم",
    loading: "جاري التحميل...",
    cancel: "إلغاء",
    empty_generic: "ماكاين والو دابا",
    access_denied: "الدخول ممنوع — هاد الصفحة خاصة بالمكتب.",
    pro_directory: "دليل الحرفيين",
    pro_directory_sub: "الحرفيون اللي نصحو بيهم الجيران",
    add_pro: "زيد حرفي",
    pro_name: "الاسم / الشركة",
    pro_profession: "الحرفة",
    pro_phone: "الهاتف",
    pro_zone: "المدينة / الحي",
    pro_note: "علاش كتنصح بيه؟",
    pro_recommended_by: "نصح بيه",
    pro_call: "اتصل",
    pro_whatsapp: "واتساب",
    pro_rate: "نقطتك",
    all_cat: "الكل",
    no_pros: "ماكاين حتى حرفي — كون أول واحد ينصح بواحد!",
    reviews: "تقييم",
    neighbourhood_pick: "توصية الحي",
    delete: "حذف",
    prof_plomberie: "السباكة",
    prof_electricite: "الكهرباء",
    prof_carrelage: "الزليج",
    prof_peinture: "الصباغة",
    prof_menuiserie: "النجارة",
    prof_climatisation: "التكييف",
    prof_serrurerie: "الحدادة",
    prof_macon: "البناء",
    prof_jardinage: "البستنة",
    prof_nettoyage: "التنظيف",
    prof_electromenager: "الأجهزة المنزلية",
    prof_autre: "أخرى",
  },
  en: {
    appName: "Rahma Bat A",
    appShort: "Condo Manager",
    nav_home: "Home",
    nav_finances: "Finances",
    nav_action: "Action",
    nav_announcements: "News",
    nav_more: "More",
    login: "Sign in",
    logout: "Sign out",
    email: "Email",
    login_title: "Welcome",
    login_subtitle: "Manage your building with full transparency",
    demo_badge: "Showcase residence",
    demo_hint: "Demo access — explore freely",
    demo_fill: "Fill demo access",
    login_error: "Wrong email or password",
    role_president: "President (Manager)",
    role_tresorier: "Treasurer",
    role_conseil: "Board member",
    role_coproprietaire: "Co-owner",
    role_gardien: "Caretaker",
    hello: "Hello",
    balance: "Cash balance",
    reserve: "Accumulated reserve",
    total_revenue: "Total revenue",
    total_expense: "Total expenses",
    cash: "Cash",
    bank: "Bank",
    next_payment: "Next antenna rent",
    available_funds: "Available funds",
    open_tickets: "Open tickets",
    quick_actions: "Quick actions",
    report_problem: "Report a problem",
    add_expense: "Add an expense",
    emergency: "Emergency",
    pinned_announcements: "Pinned announcements",
    recent_expenses: "Recent expenses",
    view_all: "View all",
    financial_health: "Building financial health",
    saved_this_period: "Saved",
    feed: "Feed",
    bank_account: "Bank account",
    antenna: "Antenna",
    reports: "Reports",
    transparency_feed: "Transparency feed",
    transparency_sub: "Every dirham, in real time",
    income: "Income",
    expense: "Expense",
    receipt: "Receipt",
    view_receipt: "View receipt",
    no_receipt: "No receipt",
    ask_question: "Ask a question",
    questions: "Questions",
    your_question: "Your question about this expense",
    send: "Send",
    answer: "Reply",
    cancelled: "Cancelled",
    by: "by",
    official_balance: "Official balance",
    statement_date: "Statement date",
    updated_ago: "Updated on",
    reconciliation_ok: "Reconciliation OK — balance matches the statement",
    reconciliation_warn: "Discrepancies to explain",
    matched_ops: "Matched operations",
    unmatched: "Discrepancies",
    import_statement: "Import a statement",
    operations: "Statement operations",
    no_bank: "No statement imported yet",
    antenna_contract: "Antenna contract",
    operator: "Operator",
    quarterly_amount: "Quarterly rent",
    contract_end: "Contract end",
    payments_history: "Payments history",
    quarterly_summary: "Quarterly summary",
    expenses_by_category: "Expenses by category",
    generate_pdf: "PDF report",
    quarter: "Quarter",
    action_title: "What would you like to do?",
    scan_invoice: "Scan an invoice",
    scan_sub: "Photo → AI fills everything",
    ss_button: "Smart drop (AI)",
    ss_button_sub: "Photo or scan → AI files everything in the right place",
    ss_title: "Smart drop",
    ss_drop: "Take a photo or choose a file",
    ss_hint: "Invoice, bank statement, contract, minutes… in French or Arabic",
    ss_pages_q: "Have you added ALL pages of the document?",
    ss_pages_hint: "Add every page (e.g. a multi-page bank statement) before starting the analysis — the AI will read them as one document.",
    ss_add_page: "Add a page",
    ss_all_added: "That's all → Analyze",
    ss_pages_added: "item(s) added",
    ss_single_pdf: "A PDF/CSV/Excel file must be sent alone. For multiple pages, use photos.",
    doc_multi_hint: "Multiple pages? Add each photo — they will be merged into one PDF.",
    ss_analyzing: "AI is reading your document…",
    ss_uploading: "Uploading photos…",
    ss_dont_leave: "Please don't leave this page during analysis, or you'll lose your photos.",
    ss_leave_confirm: "The AI is reading your photos. If you leave now, you'll lose this document. Leave anyway?",
    ss_detected: "Document recognized",
    ss_type_facture: "Invoice / expense",
    ss_type_releve_bancaire: "Bank statement",
    ss_type_document: "Official document",
    ss_dest_facture: "Will be saved in Finances → Expenses (proof archived)",
    ss_dest_releve_bancaire: "Will be imported into Finances → Bank with automatic reconciliation",
    ss_dest_document: "Will be filed in the Documents library",
    ss_wrong_type: "Wrong type? Fix it:",
    ss_confirm: "Confirm and file",
    ss_saved_facture: "Expense saved in finances",
    ss_saved_releve_bancaire: "Statement imported — reconciliation done",
    ss_saved_document: "Document filed in the library",
    ss_view: "View result",
    ss_scan_more: "Scan another document",
    ss_tx_count: "transactions detected",
    ss_statement_date: "Statement date",
    ss_closing_balance: "Closing balance (MAD)",
    ss_matched: "matched",
    ss_anomalies: "anomalies",
    ss_analyze_failed: "AI could not read this document. Try again with a sharper photo.",
    ss_amount_required: "Amount is required",
    ss_title_required: "Title is required",
    ss_type_rib: "Bank ID (RIB)",
    ss_dest_rib: "Will be filed in Finances → Bank → RIB (president & treasurer)",
    ss_saved_rib: "RIB saved in Finances → Bank",
    ss_rib_required: "RIB number is required",
    ss_bank_required: "Statement date and closing balance are required",
    rib_kind_residence: "Residence's RIB",
    rib_kind_externe: "Other RIB (supplier…)",
    rib_label: "Label (e.g. supplier name)",
    rib_holder: "Account holder",
    rib_bank: "Bank",
    rib_agency: "Branch",
    rib_number: "RIB number (24 digits)",
    rib_iban: "IBAN (optional)",
    rib_residence: "Residence's RIB",
    rib_externes: "Saved RIBs (suppliers…)",
    rib_copy: "Copy",
    rib_copied: "RIB copied",
    copy_failed: "Copy failed",
    load_failed: "Could not load data. Check your connection.",
    bkp_title: "Backups",
    bkp_sub: "Full encrypted backup + restore",
    bkp_need_password: "First set an encryption password",
    bkp_password_hint: "It protects your backups. Without it, no backup is possible.",
    bkp_set_password: "Set password",
    bkp_password_warn: "⚠️ Keep it safe: it is REQUIRED to restore. Nobody can recover it.",
    bkp_password_ph: "Encryption password",
    bkp_password_confirm: "Confirm password",
    bkp_password_min: "8 characters minimum",
    bkp_password_mismatch: "Passwords do not match",
    bkp_last: "Last backup",
    bkp_never: "None yet",
    bkp_run_now: "Back up now",
    bkp_running: "Backing up…",
    bkp_done: "Backup complete ✓",
    bkp_done_with_errors: "Backup done, but one upload failed (see history)",
    bkp_failed: "Operation failed",
    bkp_daily: "Automatic daily backup",
    bkp_hour: "Time",
    bkp_retention: "Keep (count)",
    bkp_schedule_hint: "Every day at the chosen time (Morocco time). We keep the last N; older ones are removed.",
    bkp_destinations: "Destinations",
    bkp_dest_hint: "Send each backup to one or more external storages. Fill in the connection details.",
    bkp_disabled: "Disabled",
    bkp_test: "Test",
    bkp_testing: "Testing connection…",
    bkp_test_ok: "Connection OK ✓",
    bkp_test_fail: "Connection failed",
    bkp_dest_delete_confirm: "Delete this destination?",
    bkp_dest_label: "Name (e.g. My Glacier)",
    bkp_folder: "Folder / prefix (optional)",
    bkp_s3_endpoint: "Endpoint (empty = AWS; else Wasabi/B2/MinIO)",
    bkp_az_account: "Storage account name",
    bkp_az_key: "Account key",
    bkp_sftp_user: "Username",
    bkp_sftp_dir: "Remote folder (e.g. /volume1/backups)",
    bkp_sftp_pw: "Password",
    bkp_secret_keep: "(leave empty = unchanged)",
    bkp_history: "History",
    bkp_none: "No backups yet",
    bkp_files: "files",
    bkp_records: "records",
    bkp_collections: "modules",
    bkp_kind_manual: "Manual",
    bkp_kind_auto: "Automatic",
    bkp_kind_pre_restore: "Before restore",
    bkp_restore: "Restore",
    bkp_restore_from_file: "Restore from a file",
    bkp_restore_file_hint: "Choose a downloaded .zip archive and enter its password. Useful if the server is lost or hacked.",
    bkp_choose_file: "Choose a file",
    bkp_delete_confirm: "Delete this backup?",
    bkp_restore_confirm1: "RESTORE will REPLACE all current data with this backup. Continue?",
    bkp_restore_confirm2: "Are you ABSOLUTELY sure? A safety backup will be created first.",
    bkp_restoring: "Restoring…",
    bkp_restored: "Restore complete ✓",
    bkp_bad_password: "Wrong password for this archive",
    wipe_zone_title: "Danger zone",
    wipe_title: "Wipe all data",
    wipe_desc: "PERMANENTLY erases all data (expenses, revenues, tickets, announcements, documents, meetings, contributions, other members' accounts…). Keeps only YOUR account, the building and the units (reset to empty).",
    wipe_backup_first: "Make a backup above first if you want to be able to restore everything.",
    wipe_button: "Wipe all data",
    wipe_modal_title: "Wipe all data?",
    wipe_warn: "IRREVERSIBLE action. Will be deleted: all residence data and ALL accounts except yours. Backups are preserved.",
    wipe_kept: "Kept account",
    wipe_confirm_label: "To confirm, type SUPPRIMER in capitals:",
    wipe_confirm_ph: "SUPPRIMER",
    wipe_confirm_mismatch: "Type SUPPRIMER exactly to confirm",
    wipe_running: "Wiping…",
    wipe_done: "Data wiped — the residence is ready to launch ✓",
    wipe_items: "items deleted",
    rib_delete_confirm: "Delete this RIB?",
    occ_label: "Who lives in the dwelling?",
    occ_occupant: "I live there",
    occ_loue: "Rented to a tenant",
    occ_tenant_name: "Tenant's name (optional)",
    occ_tenant_phone: "Tenant's phone (optional)",
    occ_why: "Why these details? In case of an emergency in the building (water leak, fire, damage…), the syndic must be able to quickly reach the person actually living in the dwelling. They are only shared with your consent.",
    lot_occupant_badge: "Owner-occupied",
    lot_tenant: "Tenant",
    lot_ask_tenant: "See tenant's contact (with the owner's consent)",
    lot_request_pending: "Request sent — waiting for the owner's approval",
    lot_request_sent: "Request sent to the owner",
    recon_to_revenue: "Record as revenue",
    recon_to_revenue_done: "Revenue recorded — treasury updated",
    ant_title: "Antenna contract",
    ant_operator: "Operator",
    ant_quarterly: "Quarterly rent (MAD)",
    ant_start: "Contract start",
    ant_end: "Contract end (optional)",
    ant_contact: "Operator contact (optional)",
    ant_next_due: "Next expected payment",
    ant_overdue: "Payment overdue!",
    ant_last_payment: "Last payment",
    ant_setup: "Set up the antenna contract",
    ant_required: "Quarterly rent and start date are required",
    welcome_title: "Welcome home",
    welcome_sub: "This space is yours: everything about the residence, in full transparency.",
    welcome_f1: "Track every expense with its receipt, the bank balance and the reports.",
    welcome_f2: "An issue in the building? Report it in 30 seconds (leak, elevator, cleanliness…).",
    welcome_f3: "Browse official documents and vote at general assemblies.",
    welcome_f4: "In your profile, say whether you live in the dwelling or rent it out — useful in emergencies.",
    welcome_cta: "Let's go",
    reg_lang_label: "Your language",
    reg_lang_hint: "The site and the emails will be in this language. You can change it anytime with the button at the top of the screen.",
    take_photo: "Take a photo / choose",
    analyzing: "AI is analyzing...",
    supplier: "Supplier",
    amount: "Amount (MAD)",
    vat: "VAT (MAD)",
    date: "Date",
    category: "Category",
    account: "Account",
    note: "Note",
    save: "Save",
    saved: "Saved",
    add_revenue: "Record antenna rent",
    tickets: "Requests & Incidents",
    new_ticket: "New request",
    ticket_category: "Type",
    description: "Description",
    location: "Location (floor/area)",
    status: "Status",
    create: "Create",
    my_tickets: "My open requests",
    no_tickets: "No open requests — all is well in the building",
    assigned_to: "Assigned to",
    comment: "Comment",
    announcements: "Announcements",
    new_announcement: "New announcement",
    title: "Title",
    message: "Message",
    pin: "Pin",
    no_announcements: "No announcements yet",
    building: "Building & Units",
    residents: "Residents",
    residents_sub: "Privacy respected — contact details on approval",
    apartment: "Apartment",
    you_tag: "You",
    request_contact: "Request contact details",
    request_sent: "Request sent",
    incoming_requests: "Incoming requests",
    wants_contact: "wants to see your contact details",
    authorize: "Approve",
    refuse: "Decline",
    privacy_note: "For privacy, only first name, initial and apartment are visible.",
    contact_visible: "Contact details shared",
    ideas: "Ideas box",
    ideas_sub: "Suggest, vote, improve the building together",
    new_idea: "Suggest an idea",
    idea_title: "Idea title",
    idea_desc: "Describe your idea",
    visibility: "Visibility",
    vis_public: "Visible to everyone",
    vis_prive: "Private (President & Treasurer)",
    support: "Support",
    supported: "Supported",
    supports: "supports",
    no_ideas: "No ideas yet — be the first!",
    private_idea: "Private",
    ist_nouvelle: "New",
    ist_etude: "Under review",
    ist_retenue: "Accepted",
    ist_refusee: "Declined",
    auto_translated: "Auto-translated",
    show_original: "Show original",
    show_translation: "Show translation",
    translation_hint: "Automatic translation — if in doubt, contact the author.",
    documents: "Documents",
    documents_sub: "Rules, contracts and official documents of the building",
    doc_reglement: "Condominium rules",
    doc_contrat: "Supplier contracts",
    doc_legal: "Legal documents",
    doc_pv: "Assembly minutes",
    doc_attestation: "Certificates",
    doc_facture: "Important invoices",
    doc_autre: "Other",
    add_document: "Add a document",
    edit_document: "Edit",
    doc_title: "Document title",
    doc_description: "Description (optional)",
    doc_body: "Rules text",
    doc_body_ph: "Type or paste the rules text…",
    doc_category: "Category",
    doc_supplier: "Supplier",
    doc_service_type: "Service type (elevator, cleaning…)",
    doc_start: "Start",
    doc_end: "End",
    doc_amount: "Yearly amount (MAD)",
    doc_file: "File (PDF or photo)",
    choose_file: "Choose a file / scan",
    take_photo_cam: "Take a photo",
    consult: "View",
    download: "Download",
    no_documents: "No documents in this category",
    download_restricted: "Only the president and treasurer can download files.",
    file_attached: "File attached",
    uploading: "Uploading…",
    ongoing: "Ongoing",
    doc_vis_public: "Visible to everyone",
    doc_vis_bureau: "Board only",
    doc_private_badge: "Board",
    quarterly_report: "Quarterly financial report",
    report_period: "Choose the quarter",
    download_report: "Download PDF",
    share_whatsapp: "Share on WhatsApp",
    wa_alert: "Alert on WhatsApp",
    wa_report_footer: "Full details in the Rahma Bat A app — full financial transparency.",
    treasury_total: "Total treasury",
    cash_box: "Cash box",
    cash_box_full: "Cash box (held by treasurer)",
    bank_balance_label: "Bank balance",
    advances_due: "Advances to reimburse",
    pending_expenses: "Awaiting payment",
    cash_movements: "Cash movements",
    no_movements: "No cash movements",
    add_withdrawal: "Bank withdrawal → cash box",
    withdrawal_amount: "Amount withdrawn (MAD)",
    withdrawal_label: "Label (bank, reason…)",
    record_withdrawal: "Record withdrawal",
    mov_withdrawal: "Bank withdrawal",
    mov_expense: "Invoice payment",
    mov_reimbursement: "Advance reimbursement",
    payment: "Payment",
    payment_status_label: "Payment status",
    pay_pending: "Pending",
    pay_paid: "Paid",
    payment_method_label: "Payment method",
    pm_cash: "Cash (cash box)",
    pm_bank: "Transfer / bank",
    pm_advance: "Advance (own funds)",
    pay_now: "Settle",
    choose_pay_method: "Settle expense",
    reimburse_now: "Reimburse",
    reimburse_title: "Reimburse advance",
    badge_pending: "Pending",
    badge_cash: "Paid cash",
    badge_bank: "Paid bank",
    badge_advance: "Advance to reimburse",
    badge_reimbursed: "Reimbursed",
    advanced_by_label: "Advanced by",
    pay_advanced: "Advanced by…",
    advance_by_select: "Who advanced the money?",
    advance_confirm_label: "Confirm this name",
    advance_confirmed: "Name confirmed",
    advance_select_required: "Select who advanced the money",
    advance_confirm_required: "Confirm the name of the person who advanced",
    advances_recap_title: "Advances to reimburse",
    advances_recap_sub: "Total owed per person — so nothing is forgotten",
    advances_none: "No advances awaiting reimbursement",
    advances_grand_total: "Grand total to reimburse",
    advance_invoices: "invoice(s)",
    reimburse_person_confirm: "Confirm reimbursement",
    reimburse_person_msg: "You are about to reimburse",
    to_person: "to",
    reimburse_method_hint: "If paid in cash, the amount will be debited from the cash box.",
    confirm_btn: "Confirm",
    justif_required: "Add the receipt (photo/scan) first for an advance",
    cash_only_tresorier: "Only the treasurer can pay in cash",
    topup_title: "Top up the cash box",
    topup_sub: "Bank withdrawal → cash (double validation)",
    topup_amount: "Withdrawal amount (MAD)",
    topup_label: "Bank / label",
    topup_proof: "Withdrawal receipt (photo/scan)",
    topup_proof_required: "Attach the withdrawal receipt",
    request_topup: "Request top-up",
    topups_history: "Cash top-ups",
    topup_pending: "Awaiting validation",
    topup_valid: "Approved",
    topup_refused: "Rejected",
    awaiting_president: "Awaiting president",
    approve: "Approve",
    reject: "Reject",
    reject_reason: "Rejection reason",
    requested_by: "Requested by",
    validated_by: "Approved by",
    double_val_note: "Every top-up requires validation by BOTH the treasurer and the president.",
    notifications: "Notifications",
    no_notifications: "No notifications",
    push_settings: "Push notifications",
    push_enable: "Enable notifications",
    push_enable_desc: "Get important alerts (validations, anomalies, announcements) even when the app is closed.",
    push_activate: "Enable",
    push_later: "Later",
    push_on: "Notifications on",
    push_off: "Notifications off",
    push_enabled_toast: "Notifications enabled 🔔",
    push_disabled_toast: "Notifications disabled",
    push_denied: "Notifications are blocked in your browser settings.",
    push_unsupported: "Your browser doesn't support push notifications.",
    push_test: "Send a test",
    push_test_sent: "Test notification sent",
    push_ios_hint: "On iPhone: first add the app to your Home Screen (Share → Add to Home Screen), then enable notifications.",
    mark_all_read: "Mark all as read",
    statement_imported: "Statement imported and reconciled",
    reconciling: "AI reconciliation…",
    recon_engine_ai: "Reconciled by AI",
    recon_engine_algo: "Automatic reconciliation",
    recon_matches: "Matches",
    recon_anomalies: "Anomalies to handle",
    recon_bank_only: "On statement, missing in app",
    recon_app_only: "In app, missing on statement",
    recon_resolve: "Resolve / comment",
    recon_mark_resolved: "Mark resolved",
    recon_resolved: "Anomaly resolved",
    recon_resolved_plural: "Resolved anomalies",
    recon_resolved_by: "Resolved by",
    recon_reopen: "Reopen",
    recon_comment_ph: "Explain this anomaly (e.g. pending transfer, bank fees…)",
    recon_comment_required: "Add a comment to resolve the anomaly",
    recon_open_count: "open anomalies",
    recon_accept_all: "Accept all",
    recon_accept_all_confirm: "Mark ALL open anomalies as accepted? Useful to quickly clear an old statement without commenting each one.",
    recon_accept_all_done: "Anomalies accepted",
    recurring_label_suggest: "Recurring expense? Suggested label",
    recurring_label_use: "Use",
    login_id_ph: "firstname.initial (e.g. karim.b)",
    login_pin_ph: "PIN code (4 to 6 digits)",
    login_remember: "Stay signed in on this device",
    forgot_identifier: "Forgot username?",
    forgot_pin: "Forgot PIN?",
    have_invite: "I have an invitation code",
    forgot_sent: "The president has been notified",
    forgot_pin_help: "Enter your username: the president will be notified and will reset your code.",
    forgot_identifier_help: "Enter your phone number: the president will resend your username.",
    phone_ph: "Phone number",
    notify_president: "Notify the president",
    back: "Back",
    continue: "Continue",
    activation_title: "Account activation",
    activation_step0_help: "Enter the username and invitation code received via WhatsApp.",
    invite_code_ph: "Invitation code (e.g. K7M2PA)",
    choose_pin: "Choose your PIN",
    pin_rule: "A 4 to 6 digit code that you choose.",
    confirm_pin: "Confirm PIN",
    pin_mismatch: "PIN codes do not match",
    change_pin: "Change my PIN",
    change_pin_title: "Change your PIN",
    change_pin_required_title: "PIN change required",
    change_pin_required_sub: "For your security, choose a new personal PIN before continuing.",
    change_pin_ok: "PIN updated",
    change_pin_cta: "Confirm new PIN",
    current_pin_label: "Current PIN",
    new_pin_label: "New PIN",
    confirm_pin_label: "Confirm new PIN",
    pin_need_6: "The PIN must be 6 digits",
    pin_policy_hint: "6 digits. Avoid sequences (123456) and repeated digits (000000).",
    session_expired_inactive: "Session expired due to inactivity. Please sign in again.",
    session_expiring_title: "Session about to expire",
    session_expiring_msg: "You are about to be signed out due to inactivity.",
    stay_connected: "Stay signed in",
    complete_profile: "Complete your profile",
    profile_help: "This information feeds the resident directory.",
    full_name: "Full name",
    apartment_label: "Unit number",
    finish_activation: "Activate my account",
    activation_done: "Account activated!",
    activation_done_help: "Welcome. You are now signed in.",
    directory_notice: "In the directory, neighbours only see your unit, first name and initial. Your contact details are shared only after an accepted contact request.",
    enter_app: "Enter the app",
    profile_required: "All profile fields are required",
    user_management: "User management",
    add_user: "Add",
    role_requests: "Pending approvals",
    awaiting_treasurer: "Awaiting treasurer",
    apt: "Unit",
    status_active: "Active",
    status_invited: "Pending",
    status_disabled: "Disabled",
    invite_code: "Invitation code",
    send_whatsapp: "Invite via WhatsApp",
    regenerate_code: "New code",
    edit: "Edit",
    reset_pin: "Reset PIN",
    enable: "Enable",
    disable: "Disable",
    reset_pin_confirm: "Reset this user's PIN? A new invitation code will be generated.",
    pin_reset_done: "PIN reset — send the new code",
    code_regenerated: "New code generated",
    role_approved_toast: "Change approved",
    role_rejected_toast: "Change rejected",
    name_required: "Name is required",
    user_created: "Account created — send the invitation",
    identifier_optional: "Username (leave empty = automatic)",
    email_invite_optional: "Email (optional — sends the invitation by email)",
    email_section: "Emails",
    email_configured: "Email sending enabled",
    email_not_configured: "Email not configured yet",
    email_test_btn: "Send a test email",
    email_test_ok: "Test email sent",
    create_account: "Create an account",
    have_account: "I already have an account",
    register_title: "Create my account",
    register_subtitle: "Sign up, confirm your email, then the manager will approve your access.",
    reg_name_ph: "Full name",
    reg_apartment_label: "Your apartment",
    reg_select_apartment: "Choose your apartment",
    reg_phone_ph: "Phone (WhatsApp)",
    reg_email_ph: "Email address",
    reg_pin_ph: "Choose a PIN (4 to 6 digits)",
    reg_pin_confirm_ph: "Confirm PIN",
    reg_pin_mismatch: "PINs do not match",
    reg_fields_required: "Please fill in all fields",
    reg_choose_residence: "Please choose your residence first.",
    register_submit: "Sign up",
    register_success_title: "Check your email 📬",
    register_success_msg: "We sent you a confirmation link. Click it to verify your address, then wait for the manager's approval.",
    back_to_login: "Back to login",
    verify_checking: "Confirming…",
    verify_success_title: "Email confirmed ✅",
    verify_success_msg: "Thanks! Your request was sent to the manager. You'll be able to log in once your account is approved.",
    verify_already_active: "Your account is already active. You can log in.",
    verify_error_title: "Invalid link",
    verify_error_msg: "This confirmation link is invalid or has expired. Please register again.",
    pending_registrations: "Pending registrations",
    no_pending_registrations: "No pending registrations.",
    rejected_history: "Rejected registrations",
    awaiting_email_confirm: "Waiting for the resident to confirm their email.",
    approve_registration: "Approve registration",
    registration_approved: "Registration approved",
    registration_rejected_toast: "Registration rejected",
    reject_registration_confirm: "Reject this registration?",
    active_members: "Active members",
    status_pending_email: "Email pending",
    status_pending_approval: "To approve",
    status_rejected: "Rejected",
    role_label: "Role",
    lang_label: "Preferred language",
    lang_name_fr: "French",
    lang_name_ar: "Darija",
    lang_name_en: "English",
    create_user: "Create account",
    suggested_id: "Suggested username",
    treasurer_4eyes_note: "Changing the treasurer requires the outgoing treasurer's approval (four-eyes rule).",
    force_reason_ph: "Reason if treasurer unavailable (forced, logged)",
    role_pending: "Treasurer approval required",
    profile_updated: "Profile updated",
    edit_profile: "Edit my profile",
    sans_facture_toggle: "Provider without invoice",
    sans_facture_hint: "Some tradespeople don't issue invoices. Fill in all the fields below.",
    artisan_name: "Tradesperson / company name",
    artisan_phone: "Tradesperson phone",
    service_desc: "Service description",
    intervention_at: "Date and time of the work",
    sans_facture_badge: "No invoice — declared tradesperson",
    proof_ok: "Receipt attached",
    add_proof: "Attach receipt",
    providers: "Providers",
    profile: "My profile",
    settings: "Settings",
    language: "Language",
    dark_mode: "Dark mode",
    audit_log: "Audit log",
    lots: "Units",
    lot_number: "Unit no.",
    duplex: "Duplex",
    duplexes: "duplexes",
    the_building: "The building",
    entrance: "Main entrance",
    dwellings: "dwellings",
    assemblies: "General assemblies",
    ag_new: "New assembly",
    ag_none: "No assembly yet.",
    ag_ordinaire: "Ordinary",
    ag_extraordinaire: "Extraordinary",
    ag_status_brouillon: "Draft",
    ag_status_convoquee: "Convened",
    ag_status_vote_ouvert: "Voting open",
    ag_status_cloturee: "Closed",
    ag_title_label: "Assembly title",
    ag_title_required: "Enter the assembly title",
    ag_kind: "Type",
    ag_datetime: "Date & time",
    ag_place: "Location",
    ag_quorum_required: "Quorum",
    ag_agenda: "Agenda",
    ag_add_item: "Add",
    ag_item_title: "Resolution title",
    ag_item_desc: "Description (optional)",
    ag_requires_vote: "Put to a vote",
    ag_info_point: "Information point (no vote)",
    ag_create: "Create assembly",
    ag_created: "Assembly created",
    ag_convene: "Convene",
    ag_convened: "Assembly convened — everyone notified",
    ag_open_vote: "Open voting",
    ag_opened: "Voting open",
    ag_close_vote: "Close & publish",
    ag_closed: "Assembly closed — results published",
    ag_confirm_close: "Close voting and publish results?",
    ag_delete: "Delete",
    ag_deleted: "Assembly deleted",
    ag_confirm_delete: "Delete this assembly?",
    ag_share_convocation: "Share the notice",
    ag_share_results: "Share the results",
    ag_download_pv: "Download minutes (PDF)",
    ag_participation: "Participation",
    ag_quorum_reached: "Quorum reached",
    ag_quorum_not_reached: "Quorum not reached",
    ag_my_weight: "Your voting weight",
    ag_vote_pour: "For",
    ag_vote_contre: "Against",
    ag_vote_abstention: "Abstain",
    ag_submit_vote: "Save my vote",
    ag_voted: "Vote saved",
    ag_cannot_vote: "Only co-owners vote (by their shares).",
    ag_adopted: "Adopted",
    ag_rejected: "Rejected",
    maintenance: "Maintenance log",
    legal: "Legal framework",
    cotisations: "Contributions",
    cotisations_sub: "Calls for funds split among co-owners",
    cot_new: "New call",
    cot_none: "No call for funds yet.",
    cot_kind_ordinaire: "Ordinary",
    cot_kind_travaux: "Works",
    cot_kind_exceptionnel: "Exceptional",
    cot_title_label: "Call subject (e.g. Q3 charges)",
    cot_title_required: "Enter the call subject",
    cot_amount_required: "Enter a valid total amount",
    cot_period: "Period",
    cot_period_ph: "Period (e.g. Q3 2026)",
    cot_method: "Split",
    cot_method_tantiemes: "Pro rata by shares",
    cot_method_equal: "Equal shares",
    cot_method_hint: "Pro rata: the amount is split by each unit's shares. Equal: amount divided equally across all units.",
    cot_total: "Total amount (MAD)",
    cot_due: "Due date",
    cot_note: "Note (optional)",
    cot_create: "Issue the call",
    cot_created: "Call for funds issued",
    cot_status_open: "Open",
    cot_status_closed: "Closed",
    cot_collected: "Collected",
    cot_outstanding: "Outstanding",
    cot_paid_lots: "paid",
    cot_charges: "Shares per unit",
    cot_lot: "Unit",
    cot_amount_due: "Amount due",
    cot_remaining: "Remaining",
    cs_unpaid: "Unpaid",
    cs_partial: "Partial",
    cs_paid: "Paid",
    cot_pay: "Record payment",
    cot_pay_title: "Record a payment",
    cot_pay_amount: "Amount (empty = remaining balance)",
    cot_pay_date: "Payment date",
    cot_pay_note: "Note (optional)",
    cot_pay_submit: "Confirm payment",
    cot_paid_ok: "Payment recorded",
    cot_receipt: "PDF receipt",
    cot_reset: "Reset",
    cot_reset_confirm: "Cancel all payments for this share?",
    cot_reset_ok: "Payments cancelled",
    cot_close: "Close",
    cot_reopen: "Reopen",
    cot_closed_ok: "Call closed",
    cot_reopen_ok: "Call reopened",
    cot_delete: "Delete",
    cot_delete_confirm: "Delete this call for funds and all its shares?",
    cot_deleted: "Call deleted",
    cot_impayes: "Outstanding payments",
    cot_impayes_total: "Total to collect",
    pmth_cash: "Cash",
    pmth_bank: "Transfer / bank",
    pmth_cheque: "Cheque",
    mnt_new: "New intervention",
    mnt_edit: "Edit intervention",
    mnt_none: "No intervention recorded.",
    mnt_cat_ascenseur: "Elevator",
    mnt_cat_etancheite: "Waterproofing",
    mnt_cat_extincteurs: "Fire extinguishers",
    mnt_cat_plomberie: "Plumbing",
    mnt_cat_electricite: "Electricity",
    mnt_cat_nettoyage: "Cleaning",
    mnt_cat_espaces_verts: "Green spaces",
    mnt_cat_autre: "Other",
    mnt_title: "Intervention title",
    mnt_title_required: "Enter the intervention title",
    mnt_desc: "Description (optional)",
    mnt_provider: "Provider",
    mnt_phone: "Phone",
    mnt_date: "Date done",
    mnt_cost: "Cost",
    mnt_next_due: "Next due",
    mnt_status: "Status",
    mnt_status_fait: "Done",
    mnt_status_planifie: "Planned",
    mnt_upcoming: "Upcoming due dates",
    mnt_overdue: "Overdue",
    mnt_due_soon: "Soon",
    mnt_save: "Save",
    mnt_created: "Intervention added",
    mnt_updated: "Intervention updated",
    mnt_deleted: "Intervention deleted",
    mnt_confirm_delete: "Delete this intervention?",
    rented: "Rented",
    floor: "Floor",
    surface: "Surface",
    tantiemes: "Shares",
    owner: "Owner",
    common_areas: "Common areas",
    ca_hall: "Hall",
    ca_escaliers: "Stairs",
    ca_paliers: "Landings",
    ca_toit: "Roof (Stah)",
    ca_ascenseur: "Elevator",
    ca_loge: "Guardian lodge",
    manage_users: "Manage users",
    cat_electricite: "Electricity",
    cat_eau: "Water",
    cat_ascenseur: "Elevator",
    cat_gardiennage: "Security",
    cat_nettoyage: "Cleaning",
    cat_jardinage: "Gardening",
    cat_reparations: "Repairs",
    cat_assurance: "Insurance",
    cat_syndic: "Management",
    cat_autres: "Other",
    tcat_fuite: "Water leak",
    tcat_ascenseur: "Elevator",
    tcat_electricite: "Electricity",
    "tcat_propreté": "Cleanliness",
    tcat_bruit: "Noise",
    tcat_autre: "Other",
    st_Nouveau: "New",
    st_Vu: "Seen",
    "st_En cours": "In progress",
    st_Resolu: "Resolved",
    currency: "MAD",
    loading: "Loading...",
    cancel: "Cancel",
    empty_generic: "Nothing to show yet",
    access_denied: "Access denied — this page is reserved for the board.",
    pro_directory: "Pros directory",
    pro_directory_sub: "Tradespeople recommended by your neighbours",
    add_pro: "Add a pro",
    pro_name: "Name / company",
    pro_profession: "Trade",
    pro_phone: "Phone",
    pro_zone: "City / area",
    pro_note: "Why do you recommend them?",
    pro_recommended_by: "Recommended by",
    pro_call: "Call",
    pro_whatsapp: "WhatsApp",
    pro_rate: "Your rating",
    all_cat: "All",
    no_pros: "No professionals yet — be the first to recommend one!",
    reviews: "reviews",
    neighbourhood_pick: "Neighbourhood pick",
    delete: "Delete",
    prof_plomberie: "Plumbing",
    prof_electricite: "Electricity",
    prof_carrelage: "Tiling",
    prof_peinture: "Painting",
    prof_menuiserie: "Carpentry",
    prof_climatisation: "Air conditioning",
    prof_serrurerie: "Locksmith",
    prof_macon: "Masonry",
    prof_jardinage: "Gardening",
    prof_nettoyage: "Cleaning",
    prof_electromenager: "Appliances",
    prof_autre: "Other",
  },
};
